var wd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function Cd(e) {
  return e;
}
function we(e, t, r, n, a, s, i, o, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return i(s(a(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return o(i(s(a(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return u(o(i(s(a(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function S(e, t, r, n, a, s, i, o, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return a(n(r(t(e))));
    case 6:
      return s(a(n(r(t(e)))));
    case 7:
      return i(s(a(n(r(t(e))))));
    case 8:
      return o(i(s(a(n(r(t(e)))))));
    case 9:
      return u(o(i(s(a(n(r(t(e))))))));
    default: {
      for (var l = arguments[0], h = 1; h < arguments.length; h++)
        l = arguments[h](l);
      return l;
    }
  }
}
var Id = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(a) {
      return t.apply(void 0, wd([a], n, !1));
    };
  };
}, xd = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, Od = function(e) {
  return xd(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, Uc = function(e) {
  return e._tag === "Some";
}, Kc = { _tag: "None" }, Bc = function(e) {
  return { _tag: "Some", value: e };
}, kd = function(e) {
  return e._tag === "Left";
}, Pd = function(e) {
  return e._tag === "Right";
}, qd = function(e) {
  return { _tag: "Left", left: e };
}, Vd = function(e) {
  return { _tag: "Right", right: e };
}, Md = function(e) {
  return [e];
}, Nd = [], $d = Object.prototype.hasOwnProperty, Dd = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, a) {
        return e.concat(n, a);
      }, t);
    };
  };
}, jd = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var a in e)
        $d.call(e, a) && (n[a] = e[a].concat(t[a], r[a]));
      return n;
    }
  };
}, kr = function() {
  return { concat: Cd };
}, Hd = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, Ld = Dd, ri = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Ud = Nd, Kd = function(e, t) {
  return e < 0 || e >= t.length;
}, Bd = function(e) {
  return function(t) {
    return ri(ri([], t, !0), [e], !1);
  };
}, Gd = Bd, Fd = Md, ge = {
  equals: function(e, t) {
    return e === t;
  }
}, Zd = {
  concat: function(e, t) {
    return e + t;
  }
}, Wd = "", os = {
  concat: Zd.concat,
  empty: Wd
};
ge.equals;
var Gc = function(e) {
  return e.trim();
}, Fc = function(e) {
  return e.length === 0;
}, Kt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Pr, ni;
function Jd() {
  if (ni) return Pr;
  ni = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Pr = e, Pr;
}
var qr, ai;
function cs() {
  if (ai) return qr;
  ai = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return qr = e, qr;
}
var Vr, si;
function sr() {
  if (si) return Vr;
  si = 1;
  var e = cs();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Vr = t, Vr;
}
var Mr, ii;
function zd() {
  if (ii) return Mr;
  ii = 1;
  var e = sr(), t = Array.prototype, r = t.splice;
  function n(a) {
    var s = this.__data__, i = e(s, a);
    if (i < 0)
      return !1;
    var o = s.length - 1;
    return i == o ? s.pop() : r.call(s, i, 1), --this.size, !0;
  }
  return Mr = n, Mr;
}
var Nr, oi;
function Qd() {
  if (oi) return Nr;
  oi = 1;
  var e = sr();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return Nr = t, Nr;
}
var $r, ci;
function Yd() {
  if (ci) return $r;
  ci = 1;
  var e = sr();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return $r = t, $r;
}
var Dr, ui;
function Xd() {
  if (ui) return Dr;
  ui = 1;
  var e = sr();
  function t(r, n) {
    var a = this.__data__, s = e(a, r);
    return s < 0 ? (++this.size, a.push([r, n])) : a[s][1] = n, this;
  }
  return Dr = t, Dr;
}
var jr, li;
function ir() {
  if (li) return jr;
  li = 1;
  var e = Jd(), t = zd(), r = Qd(), n = Yd(), a = Xd();
  function s(i) {
    var o = -1, u = i == null ? 0 : i.length;
    for (this.clear(); ++o < u; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, jr = s, jr;
}
var Hr, di;
function ef() {
  if (di) return Hr;
  di = 1;
  var e = ir();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Hr = t, Hr;
}
var Lr, fi;
function tf() {
  if (fi) return Lr;
  fi = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Lr = e, Lr;
}
var Ur, hi;
function rf() {
  if (hi) return Ur;
  hi = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Ur = e, Ur;
}
var Kr, pi;
function nf() {
  if (pi) return Kr;
  pi = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Kr = e, Kr;
}
var Br, yi;
function Wc() {
  if (yi) return Br;
  yi = 1;
  var e = typeof Kt == "object" && Kt && Kt.Object === Object && Kt;
  return Br = e, Br;
}
var Gr, mi;
function he() {
  if (mi) return Gr;
  mi = 1;
  var e = Wc(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Gr = r, Gr;
}
var Fr, vi;
function or() {
  if (vi) return Fr;
  vi = 1;
  var e = he(), t = e.Symbol;
  return Fr = t, Fr;
}
var Zr, gi;
function af() {
  if (gi) return Zr;
  gi = 1;
  var e = or(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function s(i) {
    var o = r.call(i, a), u = i[a];
    try {
      i[a] = void 0;
      var l = !0;
    } catch {
    }
    var h = n.call(i);
    return l && (o ? i[a] = u : delete i[a]), h;
  }
  return Zr = s, Zr;
}
var Wr, _i;
function sf() {
  if (_i) return Wr;
  _i = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Wr = r, Wr;
}
var Jr, bi;
function cr() {
  if (bi) return Jr;
  bi = 1;
  var e = or(), t = af(), r = sf(), n = "[object Null]", a = "[object Undefined]", s = e ? e.toStringTag : void 0;
  function i(o) {
    return o == null ? o === void 0 ? a : n : s && s in Object(o) ? t(o) : r(o);
  }
  return Jr = i, Jr;
}
var zr, Si;
function xt() {
  if (Si) return zr;
  Si = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return zr = e, zr;
}
var Qr, Ai;
function Jc() {
  if (Ai) return Qr;
  Ai = 1;
  var e = cr(), t = xt(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", s = "[object Proxy]";
  function i(o) {
    if (!t(o))
      return !1;
    var u = e(o);
    return u == n || u == a || u == r || u == s;
  }
  return Qr = i, Qr;
}
var Yr, Ti;
function of() {
  if (Ti) return Yr;
  Ti = 1;
  var e = he(), t = e["__core-js_shared__"];
  return Yr = t, Yr;
}
var Xr, Ei;
function cf() {
  if (Ei) return Xr;
  Ei = 1;
  var e = of(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return Xr = r, Xr;
}
var en, Ri;
function zc() {
  if (Ri) return en;
  Ri = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return en = r, en;
}
var tn, wi;
function uf() {
  if (wi) return tn;
  wi = 1;
  var e = Jc(), t = cf(), r = xt(), n = zc(), a = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, i = Function.prototype, o = Object.prototype, u = i.toString, l = o.hasOwnProperty, h = RegExp(
    "^" + u.call(l).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function m(R) {
    if (!r(R) || t(R))
      return !1;
    var N = e(R) ? h : s;
    return N.test(n(R));
  }
  return tn = m, tn;
}
var rn, Ci;
function lf() {
  if (Ci) return rn;
  Ci = 1;
  function e(t, r) {
    return t?.[r];
  }
  return rn = e, rn;
}
var nn, Ii;
function Fe() {
  if (Ii) return nn;
  Ii = 1;
  var e = uf(), t = lf();
  function r(n, a) {
    var s = t(n, a);
    return e(s) ? s : void 0;
  }
  return nn = r, nn;
}
var an, xi;
function us() {
  if (xi) return an;
  xi = 1;
  var e = Fe(), t = he(), r = e(t, "Map");
  return an = r, an;
}
var sn, Oi;
function ur() {
  if (Oi) return sn;
  Oi = 1;
  var e = Fe(), t = e(Object, "create");
  return sn = t, sn;
}
var on, ki;
function df() {
  if (ki) return on;
  ki = 1;
  var e = ur();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return on = t, on;
}
var cn, Pi;
function ff() {
  if (Pi) return cn;
  Pi = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return cn = e, cn;
}
var un, qi;
function hf() {
  if (qi) return un;
  qi = 1;
  var e = ur(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    var i = this.__data__;
    if (e) {
      var o = i[s];
      return o === t ? void 0 : o;
    }
    return n.call(i, s) ? i[s] : void 0;
  }
  return un = a, un;
}
var ln, Vi;
function pf() {
  if (Vi) return ln;
  Vi = 1;
  var e = ur(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var s = this.__data__;
    return e ? s[a] !== void 0 : r.call(s, a);
  }
  return ln = n, ln;
}
var dn, Mi;
function yf() {
  if (Mi) return dn;
  Mi = 1;
  var e = ur(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var s = this.__data__;
    return this.size += this.has(n) ? 0 : 1, s[n] = e && a === void 0 ? t : a, this;
  }
  return dn = r, dn;
}
var fn, Ni;
function mf() {
  if (Ni) return fn;
  Ni = 1;
  var e = df(), t = ff(), r = hf(), n = pf(), a = yf();
  function s(i) {
    var o = -1, u = i == null ? 0 : i.length;
    for (this.clear(); ++o < u; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, fn = s, fn;
}
var hn, $i;
function vf() {
  if ($i) return hn;
  $i = 1;
  var e = mf(), t = ir(), r = us();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return hn = n, hn;
}
var pn, Di;
function gf() {
  if (Di) return pn;
  Di = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return pn = e, pn;
}
var yn, ji;
function lr() {
  if (ji) return yn;
  ji = 1;
  var e = gf();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return yn = t, yn;
}
var mn, Hi;
function _f() {
  if (Hi) return mn;
  Hi = 1;
  var e = lr();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return mn = t, mn;
}
var vn, Li;
function bf() {
  if (Li) return vn;
  Li = 1;
  var e = lr();
  function t(r) {
    return e(this, r).get(r);
  }
  return vn = t, vn;
}
var gn, Ui;
function Sf() {
  if (Ui) return gn;
  Ui = 1;
  var e = lr();
  function t(r) {
    return e(this, r).has(r);
  }
  return gn = t, gn;
}
var _n, Ki;
function Af() {
  if (Ki) return _n;
  Ki = 1;
  var e = lr();
  function t(r, n) {
    var a = e(this, r), s = a.size;
    return a.set(r, n), this.size += a.size == s ? 0 : 1, this;
  }
  return _n = t, _n;
}
var bn, Bi;
function Qc() {
  if (Bi) return bn;
  Bi = 1;
  var e = vf(), t = _f(), r = bf(), n = Sf(), a = Af();
  function s(i) {
    var o = -1, u = i == null ? 0 : i.length;
    for (this.clear(); ++o < u; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, bn = s, bn;
}
var Sn, Gi;
function Tf() {
  if (Gi) return Sn;
  Gi = 1;
  var e = ir(), t = us(), r = Qc(), n = 200;
  function a(s, i) {
    var o = this.__data__;
    if (o instanceof e) {
      var u = o.__data__;
      if (!t || u.length < n - 1)
        return u.push([s, i]), this.size = ++o.size, this;
      o = this.__data__ = new r(u);
    }
    return o.set(s, i), this.size = o.size, this;
  }
  return Sn = a, Sn;
}
var An, Fi;
function Yc() {
  if (Fi) return An;
  Fi = 1;
  var e = ir(), t = ef(), r = tf(), n = rf(), a = nf(), s = Tf();
  function i(o) {
    var u = this.__data__ = new e(o);
    this.size = u.size;
  }
  return i.prototype.clear = t, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = a, i.prototype.set = s, An = i, An;
}
var Tn, Zi;
function Ef() {
  if (Zi) return Tn;
  Zi = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a && r(t[n], n, t) !== !1; )
      ;
    return t;
  }
  return Tn = e, Tn;
}
var En, Wi;
function Rf() {
  if (Wi) return En;
  Wi = 1;
  var e = Fe(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return En = t, En;
}
var Rn, Ji;
function Xc() {
  if (Ji) return Rn;
  Ji = 1;
  var e = Rf();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return Rn = t, Rn;
}
var wn, zi;
function eu() {
  if (zi) return wn;
  zi = 1;
  var e = Xc(), t = cs(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o) {
    var u = s[i];
    (!(n.call(s, i) && t(u, o)) || o === void 0 && !(i in s)) && e(s, i, o);
  }
  return wn = a, wn;
}
var Cn, Qi;
function dr() {
  if (Qi) return Cn;
  Qi = 1;
  var e = eu(), t = Xc();
  function r(n, a, s, i) {
    var o = !s;
    s || (s = {});
    for (var u = -1, l = a.length; ++u < l; ) {
      var h = a[u], m = i ? i(s[h], n[h], h, s, n) : void 0;
      m === void 0 && (m = n[h]), o ? t(s, h, m) : e(s, h, m);
    }
    return s;
  }
  return Cn = r, Cn;
}
var In, Yi;
function wf() {
  if (Yi) return In;
  Yi = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return In = e, In;
}
var xn, Xi;
function yt() {
  if (Xi) return xn;
  Xi = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return xn = e, xn;
}
var On, eo;
function Cf() {
  if (eo) return On;
  eo = 1;
  var e = cr(), t = yt(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return On = n, On;
}
var kn, to;
function If() {
  if (to) return kn;
  to = 1;
  var e = Cf(), t = yt(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, s = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(i) {
    return t(i) && n.call(i, "callee") && !a.call(i, "callee");
  };
  return kn = s, kn;
}
var Pn, ro;
function fr() {
  if (ro) return Pn;
  ro = 1;
  var e = Array.isArray;
  return Pn = e, Pn;
}
var _t = { exports: {} }, qn, no;
function xf() {
  if (no) return qn;
  no = 1;
  function e() {
    return !1;
  }
  return qn = e, qn;
}
_t.exports;
var ao;
function ls() {
  return ao || (ao = 1, (function(e, t) {
    var r = he(), n = xf(), a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, i = s && s.exports === a, o = i ? r.Buffer : void 0, u = o ? o.isBuffer : void 0, l = u || n;
    e.exports = l;
  })(_t, _t.exports)), _t.exports;
}
var Vn, so;
function Of() {
  if (so) return Vn;
  so = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var s = typeof n;
    return a = a ?? e, !!a && (s == "number" || s != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return Vn = r, Vn;
}
var Mn, io;
function tu() {
  if (io) return Mn;
  io = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Mn = t, Mn;
}
var Nn, oo;
function kf() {
  if (oo) return Nn;
  oo = 1;
  var e = cr(), t = tu(), r = yt(), n = "[object Arguments]", a = "[object Array]", s = "[object Boolean]", i = "[object Date]", o = "[object Error]", u = "[object Function]", l = "[object Map]", h = "[object Number]", m = "[object Object]", R = "[object RegExp]", N = "[object Set]", U = "[object String]", D = "[object WeakMap]", M = "[object ArrayBuffer]", V = "[object DataView]", C = "[object Float32Array]", B = "[object Float64Array]", k = "[object Int8Array]", G = "[object Int16Array]", P = "[object Int32Array]", x = "[object Uint8Array]", W = "[object Uint8ClampedArray]", j = "[object Uint16Array]", re = "[object Uint32Array]", I = {};
  I[C] = I[B] = I[k] = I[G] = I[P] = I[x] = I[W] = I[j] = I[re] = !0, I[n] = I[a] = I[M] = I[s] = I[V] = I[i] = I[o] = I[u] = I[l] = I[h] = I[m] = I[R] = I[N] = I[U] = I[D] = !1;
  function X(ae) {
    return r(ae) && t(ae.length) && !!I[e(ae)];
  }
  return Nn = X, Nn;
}
var $n, co;
function ds() {
  if (co) return $n;
  co = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return $n = e, $n;
}
var bt = { exports: {} };
bt.exports;
var uo;
function fs() {
  return uo || (uo = 1, (function(e, t) {
    var r = Wc(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s && r.process, o = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || i && i.binding && i.binding("util");
      } catch {
      }
    })();
    e.exports = o;
  })(bt, bt.exports)), bt.exports;
}
var Dn, lo;
function ru() {
  if (lo) return Dn;
  lo = 1;
  var e = kf(), t = ds(), r = fs(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return Dn = a, Dn;
}
var jn, fo;
function nu() {
  if (fo) return jn;
  fo = 1;
  var e = wf(), t = If(), r = fr(), n = ls(), a = Of(), s = ru(), i = Object.prototype, o = i.hasOwnProperty;
  function u(l, h) {
    var m = r(l), R = !m && t(l), N = !m && !R && n(l), U = !m && !R && !N && s(l), D = m || R || N || U, M = D ? e(l.length, String) : [], V = M.length;
    for (var C in l)
      (h || o.call(l, C)) && !(D && // Safari 9 has enumerable `arguments.length` in strict mode.
      (C == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      N && (C == "offset" || C == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      U && (C == "buffer" || C == "byteLength" || C == "byteOffset") || // Skip index properties.
      a(C, V))) && M.push(C);
    return M;
  }
  return jn = u, jn;
}
var Hn, ho;
function hs() {
  if (ho) return Hn;
  ho = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return Hn = t, Hn;
}
var Ln, po;
function au() {
  if (po) return Ln;
  po = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return Ln = e, Ln;
}
var Un, yo;
function Pf() {
  if (yo) return Un;
  yo = 1;
  var e = au(), t = e(Object.keys, Object);
  return Un = t, Un;
}
var Kn, mo;
function qf() {
  if (mo) return Kn;
  mo = 1;
  var e = hs(), t = Pf(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    if (!e(s))
      return t(s);
    var i = [];
    for (var o in Object(s))
      n.call(s, o) && o != "constructor" && i.push(o);
    return i;
  }
  return Kn = a, Kn;
}
var Bn, vo;
function su() {
  if (vo) return Bn;
  vo = 1;
  var e = Jc(), t = tu();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return Bn = r, Bn;
}
var Gn, go;
function ps() {
  if (go) return Gn;
  go = 1;
  var e = nu(), t = qf(), r = su();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return Gn = n, Gn;
}
var Fn, _o;
function Vf() {
  if (_o) return Fn;
  _o = 1;
  var e = dr(), t = ps();
  function r(n, a) {
    return n && e(a, t(a), n);
  }
  return Fn = r, Fn;
}
var Zn, bo;
function Mf() {
  if (bo) return Zn;
  bo = 1;
  function e(t) {
    var r = [];
    if (t != null)
      for (var n in Object(t))
        r.push(n);
    return r;
  }
  return Zn = e, Zn;
}
var Wn, So;
function Nf() {
  if (So) return Wn;
  So = 1;
  var e = xt(), t = hs(), r = Mf(), n = Object.prototype, a = n.hasOwnProperty;
  function s(i) {
    if (!e(i))
      return r(i);
    var o = t(i), u = [];
    for (var l in i)
      l == "constructor" && (o || !a.call(i, l)) || u.push(l);
    return u;
  }
  return Wn = s, Wn;
}
var Jn, Ao;
function ys() {
  if (Ao) return Jn;
  Ao = 1;
  var e = nu(), t = Nf(), r = su();
  function n(a) {
    return r(a) ? e(a, !0) : t(a);
  }
  return Jn = n, Jn;
}
var zn, To;
function $f() {
  if (To) return zn;
  To = 1;
  var e = dr(), t = ys();
  function r(n, a) {
    return n && e(a, t(a), n);
  }
  return zn = r, zn;
}
var St = { exports: {} };
St.exports;
var Eo;
function Df() {
  return Eo || (Eo = 1, (function(e, t) {
    var r = he(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
    function u(l, h) {
      if (h)
        return l.slice();
      var m = l.length, R = o ? o(m) : new l.constructor(m);
      return l.copy(R), R;
    }
    e.exports = u;
  })(St, St.exports)), St.exports;
}
var Qn, Ro;
function jf() {
  if (Ro) return Qn;
  Ro = 1;
  function e(t, r) {
    var n = -1, a = t.length;
    for (r || (r = Array(a)); ++n < a; )
      r[n] = t[n];
    return r;
  }
  return Qn = e, Qn;
}
var Yn, wo;
function Hf() {
  if (wo) return Yn;
  wo = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, s = 0, i = []; ++n < a; ) {
      var o = t[n];
      r(o, n, t) && (i[s++] = o);
    }
    return i;
  }
  return Yn = e, Yn;
}
var Xn, Co;
function iu() {
  if (Co) return Xn;
  Co = 1;
  function e() {
    return [];
  }
  return Xn = e, Xn;
}
var ea, Io;
function ms() {
  if (Io) return ea;
  Io = 1;
  var e = Hf(), t = iu(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, s = a ? function(i) {
    return i == null ? [] : (i = Object(i), e(a(i), function(o) {
      return n.call(i, o);
    }));
  } : t;
  return ea = s, ea;
}
var ta, xo;
function Lf() {
  if (xo) return ta;
  xo = 1;
  var e = dr(), t = ms();
  function r(n, a) {
    return e(n, t(n), a);
  }
  return ta = r, ta;
}
var ra, Oo;
function ou() {
  if (Oo) return ra;
  Oo = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, s = t.length; ++n < a; )
      t[s + n] = r[n];
    return t;
  }
  return ra = e, ra;
}
var na, ko;
function cu() {
  if (ko) return na;
  ko = 1;
  var e = au(), t = e(Object.getPrototypeOf, Object);
  return na = t, na;
}
var aa, Po;
function uu() {
  if (Po) return aa;
  Po = 1;
  var e = ou(), t = cu(), r = ms(), n = iu(), a = Object.getOwnPropertySymbols, s = a ? function(i) {
    for (var o = []; i; )
      e(o, r(i)), i = t(i);
    return o;
  } : n;
  return aa = s, aa;
}
var sa, qo;
function Uf() {
  if (qo) return sa;
  qo = 1;
  var e = dr(), t = uu();
  function r(n, a) {
    return e(n, t(n), a);
  }
  return sa = r, sa;
}
var ia, Vo;
function lu() {
  if (Vo) return ia;
  Vo = 1;
  var e = ou(), t = fr();
  function r(n, a, s) {
    var i = a(n);
    return t(n) ? i : e(i, s(n));
  }
  return ia = r, ia;
}
var oa, Mo;
function du() {
  if (Mo) return oa;
  Mo = 1;
  var e = lu(), t = ms(), r = ps();
  function n(a) {
    return e(a, r, t);
  }
  return oa = n, oa;
}
var ca, No;
function Kf() {
  if (No) return ca;
  No = 1;
  var e = lu(), t = uu(), r = ys();
  function n(a) {
    return e(a, r, t);
  }
  return ca = n, ca;
}
var ua, $o;
function Bf() {
  if ($o) return ua;
  $o = 1;
  var e = Fe(), t = he(), r = e(t, "DataView");
  return ua = r, ua;
}
var la, Do;
function Gf() {
  if (Do) return la;
  Do = 1;
  var e = Fe(), t = he(), r = e(t, "Promise");
  return la = r, la;
}
var da, jo;
function Ff() {
  if (jo) return da;
  jo = 1;
  var e = Fe(), t = he(), r = e(t, "Set");
  return da = r, da;
}
var fa, Ho;
function Zf() {
  if (Ho) return fa;
  Ho = 1;
  var e = Fe(), t = he(), r = e(t, "WeakMap");
  return fa = r, fa;
}
var ha, Lo;
function hr() {
  if (Lo) return ha;
  Lo = 1;
  var e = Bf(), t = us(), r = Gf(), n = Ff(), a = Zf(), s = cr(), i = zc(), o = "[object Map]", u = "[object Object]", l = "[object Promise]", h = "[object Set]", m = "[object WeakMap]", R = "[object DataView]", N = i(e), U = i(t), D = i(r), M = i(n), V = i(a), C = s;
  return (e && C(new e(new ArrayBuffer(1))) != R || t && C(new t()) != o || r && C(r.resolve()) != l || n && C(new n()) != h || a && C(new a()) != m) && (C = function(B) {
    var k = s(B), G = k == u ? B.constructor : void 0, P = G ? i(G) : "";
    if (P)
      switch (P) {
        case N:
          return R;
        case U:
          return o;
        case D:
          return l;
        case M:
          return h;
        case V:
          return m;
      }
    return k;
  }), ha = C, ha;
}
var pa, Uo;
function Wf() {
  if (Uo) return pa;
  Uo = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function r(n) {
    var a = n.length, s = new n.constructor(a);
    return a && typeof n[0] == "string" && t.call(n, "index") && (s.index = n.index, s.input = n.input), s;
  }
  return pa = r, pa;
}
var ya, Ko;
function fu() {
  if (Ko) return ya;
  Ko = 1;
  var e = he(), t = e.Uint8Array;
  return ya = t, ya;
}
var ma, Bo;
function vs() {
  if (Bo) return ma;
  Bo = 1;
  var e = fu();
  function t(r) {
    var n = new r.constructor(r.byteLength);
    return new e(n).set(new e(r)), n;
  }
  return ma = t, ma;
}
var va, Go;
function Jf() {
  if (Go) return va;
  Go = 1;
  var e = vs();
  function t(r, n) {
    var a = n ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return va = t, va;
}
var ga, Fo;
function zf() {
  if (Fo) return ga;
  Fo = 1;
  var e = /\w*$/;
  function t(r) {
    var n = new r.constructor(r.source, e.exec(r));
    return n.lastIndex = r.lastIndex, n;
  }
  return ga = t, ga;
}
var _a, Zo;
function Qf() {
  if (Zo) return _a;
  Zo = 1;
  var e = or(), t = e ? e.prototype : void 0, r = t ? t.valueOf : void 0;
  function n(a) {
    return r ? Object(r.call(a)) : {};
  }
  return _a = n, _a;
}
var ba, Wo;
function Yf() {
  if (Wo) return ba;
  Wo = 1;
  var e = vs();
  function t(r, n) {
    var a = n ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return ba = t, ba;
}
var Sa, Jo;
function Xf() {
  if (Jo) return Sa;
  Jo = 1;
  var e = vs(), t = Jf(), r = zf(), n = Qf(), a = Yf(), s = "[object Boolean]", i = "[object Date]", o = "[object Map]", u = "[object Number]", l = "[object RegExp]", h = "[object Set]", m = "[object String]", R = "[object Symbol]", N = "[object ArrayBuffer]", U = "[object DataView]", D = "[object Float32Array]", M = "[object Float64Array]", V = "[object Int8Array]", C = "[object Int16Array]", B = "[object Int32Array]", k = "[object Uint8Array]", G = "[object Uint8ClampedArray]", P = "[object Uint16Array]", x = "[object Uint32Array]";
  function W(j, re, I) {
    var X = j.constructor;
    switch (re) {
      case N:
        return e(j);
      case s:
      case i:
        return new X(+j);
      case U:
        return t(j, I);
      case D:
      case M:
      case V:
      case C:
      case B:
      case k:
      case G:
      case P:
      case x:
        return a(j, I);
      case o:
        return new X();
      case u:
      case m:
        return new X(j);
      case l:
        return r(j);
      case h:
        return new X();
      case R:
        return n(j);
    }
  }
  return Sa = W, Sa;
}
var Aa, zo;
function eh() {
  if (zo) return Aa;
  zo = 1;
  var e = xt(), t = Object.create, r = /* @__PURE__ */ (function() {
    function n() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (t)
        return t(a);
      n.prototype = a;
      var s = new n();
      return n.prototype = void 0, s;
    };
  })();
  return Aa = r, Aa;
}
var Ta, Qo;
function th() {
  if (Qo) return Ta;
  Qo = 1;
  var e = eh(), t = cu(), r = hs();
  function n(a) {
    return typeof a.constructor == "function" && !r(a) ? e(t(a)) : {};
  }
  return Ta = n, Ta;
}
var Ea, Yo;
function rh() {
  if (Yo) return Ea;
  Yo = 1;
  var e = hr(), t = yt(), r = "[object Map]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Ea = n, Ea;
}
var Ra, Xo;
function nh() {
  if (Xo) return Ra;
  Xo = 1;
  var e = rh(), t = ds(), r = fs(), n = r && r.isMap, a = n ? t(n) : e;
  return Ra = a, Ra;
}
var wa, ec;
function ah() {
  if (ec) return wa;
  ec = 1;
  var e = hr(), t = yt(), r = "[object Set]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return wa = n, wa;
}
var Ca, tc;
function sh() {
  if (tc) return Ca;
  tc = 1;
  var e = ah(), t = ds(), r = fs(), n = r && r.isSet, a = n ? t(n) : e;
  return Ca = a, Ca;
}
var Ia, rc;
function ih() {
  if (rc) return Ia;
  rc = 1;
  var e = Yc(), t = Ef(), r = eu(), n = Vf(), a = $f(), s = Df(), i = jf(), o = Lf(), u = Uf(), l = du(), h = Kf(), m = hr(), R = Wf(), N = Xf(), U = th(), D = fr(), M = ls(), V = nh(), C = xt(), B = sh(), k = ps(), G = ys(), P = 1, x = 2, W = 4, j = "[object Arguments]", re = "[object Array]", I = "[object Boolean]", X = "[object Date]", ae = "[object Error]", Ye = "[object Function]", Xe = "[object GeneratorFunction]", Or = "[object Map]", id = "[object Number]", Qs = "[object Object]", od = "[object RegExp]", cd = "[object Set]", ud = "[object String]", ld = "[object Symbol]", dd = "[object WeakMap]", fd = "[object ArrayBuffer]", hd = "[object DataView]", pd = "[object Float32Array]", yd = "[object Float64Array]", md = "[object Int8Array]", vd = "[object Int16Array]", gd = "[object Int32Array]", _d = "[object Uint8Array]", bd = "[object Uint8ClampedArray]", Sd = "[object Uint16Array]", Ad = "[object Uint32Array]", H = {};
  H[j] = H[re] = H[fd] = H[hd] = H[I] = H[X] = H[pd] = H[yd] = H[md] = H[vd] = H[gd] = H[Or] = H[id] = H[Qs] = H[od] = H[cd] = H[ud] = H[ld] = H[_d] = H[bd] = H[Sd] = H[Ad] = !0, H[ae] = H[Ye] = H[dd] = !1;
  function jt($, et, tt, Td, Ht, Te) {
    var ne, Lt = et & P, Ut = et & x, Ed = et & W;
    if (tt && (ne = Ht ? tt($, Td, Ht, Te) : tt($)), ne !== void 0)
      return ne;
    if (!C($))
      return $;
    var Ys = D($);
    if (Ys) {
      if (ne = R($), !Lt)
        return i($, ne);
    } else {
      var rt = m($), Xs = rt == Ye || rt == Xe;
      if (M($))
        return s($, Lt);
      if (rt == Qs || rt == j || Xs && !Ht) {
        if (ne = Ut || Xs ? {} : U($), !Lt)
          return Ut ? u($, a(ne, $)) : o($, n(ne, $));
      } else {
        if (!H[rt])
          return Ht ? $ : {};
        ne = N($, rt, Lt);
      }
    }
    Te || (Te = new e());
    var ei = Te.get($);
    if (ei)
      return ei;
    Te.set($, ne), B($) ? $.forEach(function(Ee) {
      ne.add(jt(Ee, et, tt, Ee, $, Te));
    }) : V($) && $.forEach(function(Ee, $e) {
      ne.set($e, jt(Ee, et, tt, $e, $, Te));
    });
    var Rd = Ed ? Ut ? h : l : Ut ? G : k, ti = Ys ? void 0 : Rd($);
    return t(ti || $, function(Ee, $e) {
      ti && ($e = Ee, Ee = $[$e]), r(ne, $e, jt(Ee, et, tt, $e, $, Te));
    }), ne;
  }
  return Ia = jt, Ia;
}
var xa, nc;
function oh() {
  if (nc) return xa;
  nc = 1;
  var e = ih(), t = 1, r = 4;
  function n(a) {
    return e(a, t | r);
  }
  return xa = n, xa;
}
var ch = oh();
const uh = /* @__PURE__ */ Zc(ch);
var q;
(function(e) {
  e.assertEqual = (a) => {
  };
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(q || (q = {}));
var ac;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(ac || (ac = {}));
const v = q.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Re = (e) => {
  switch (typeof e) {
    case "undefined":
      return v.undefined;
    case "string":
      return v.string;
    case "number":
      return Number.isNaN(e) ? v.nan : v.number;
    case "boolean":
      return v.boolean;
    case "function":
      return v.function;
    case "bigint":
      return v.bigint;
    case "symbol":
      return v.symbol;
    case "object":
      return Array.isArray(e) ? v.array : e === null ? v.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? v.promise : typeof Map < "u" && e instanceof Map ? v.map : typeof Set < "u" && e instanceof Set ? v.set : typeof Date < "u" && e instanceof Date ? v.date : v.object;
    default:
      return v.unknown;
  }
}, p = q.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Ae extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, u = 0;
          for (; u < i.path.length; ) {
            const l = i.path[u];
            u === i.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(r(i))) : o[l] = o[l] || { _errors: [] }, o = o[l], u++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof Ae))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, q.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Ae.create = (e) => new Ae(e);
const za = (e, t) => {
  let r;
  switch (e.code) {
    case p.invalid_type:
      e.received === v.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case p.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, q.jsonStringifyReplacer)}`;
      break;
    case p.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${q.joinValues(e.keys, ", ")}`;
      break;
    case p.invalid_union:
      r = "Invalid input";
      break;
    case p.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${q.joinValues(e.options)}`;
      break;
    case p.invalid_enum_value:
      r = `Invalid enum value. Expected ${q.joinValues(e.options)}, received '${e.received}'`;
      break;
    case p.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case p.invalid_return_type:
      r = "Invalid function return type";
      break;
    case p.invalid_date:
      r = "Invalid date";
      break;
    case p.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : q.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case p.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case p.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case p.custom:
      r = "Invalid input";
      break;
    case p.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case p.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case p.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, q.assertNever(e);
  }
  return { message: r };
};
let lh = za;
function dh() {
  return lh;
}
const fh = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const u = n.filter((l) => !!l).slice().reverse();
  for (const l of u)
    o = l(i, { data: t, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function y(e, t) {
  const r = dh(), n = fh({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === za ? void 0 : za
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class te {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return T;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return te.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return T;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: t.value, value: n };
  }
}
const T = Object.freeze({
  status: "aborted"
}), At = (e) => ({ status: "dirty", value: e }), oe = (e) => ({ status: "valid", value: e }), sc = (e) => e.status === "aborted", ic = (e) => e.status === "dirty", ct = (e) => e.status === "valid", Bt = (e) => typeof Promise < "u" && e instanceof Promise;
var g;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t?.message;
})(g || (g = {}));
var Gt = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, hu = function(e, t, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, Tt, Et;
class de {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const oc = (e, t) => {
  if (ct(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Ae(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function w(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, o) => {
    const { message: u } = e;
    return i.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: u ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: u ?? r ?? o.defaultError };
  }, description: a };
}
class O {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Re(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Re(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new te(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Re(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Bt(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: r?.async ?? !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Re(t)
    }, a = this._parseSync({ data: t, path: n.path, parent: n });
    return oc(n, a);
  }
  "~validate"(t) {
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Re(t)
    };
    if (!this["~standard"].async)
      try {
        const n = this._parseSync({ data: t, path: [], parent: r });
        return ct(n) ? {
          value: n.value
        } : {
          issues: r.common.issues
        };
      } catch (n) {
        n?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((n) => ct(n) ? {
      value: n.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Re(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (Bt(a) ? a : Promise.resolve(a));
    return oc(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = t(a), o = () => s.addIssue({
        code: p.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => u ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new Be({
      schema: this,
      typeName: A.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return Se.create(this, this._def);
  }
  nullable() {
    return Ge.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return le.create(this);
  }
  promise() {
    return Yt.create(this, this._def);
  }
  or(t) {
    return Zt.create([this, t], this._def);
  }
  and(t) {
    return Wt.create(this, t, this._def);
  }
  transform(t) {
    return new Be({
      ...w(this._def),
      schema: this,
      typeName: A.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Xt({
      ...w(this._def),
      innerType: this,
      defaultValue: r,
      typeName: A.ZodDefault
    });
  }
  brand() {
    return new vu({
      typeName: A.ZodBranded,
      type: this,
      ...w(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new er({
      ...w(this._def),
      innerType: this,
      catchValue: r,
      typeName: A.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return _s.create(this, t);
  }
  readonly() {
    return tr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const hh = /^c[^\s-]{8,}$/i, ph = /^[0-9a-z]+$/, yh = /^[0-9A-HJKMNP-TV-Z]{26}$/i, mh = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, vh = /^[a-z0-9_-]{21}$/i, gh = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, _h = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, bh = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Sh = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Oa;
const Ah = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Th = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Eh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Rh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, wh = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Ch = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, pu = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ih = new RegExp(`^${pu}$`);
function yu(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function xh(e) {
  return new RegExp(`^${yu(e)}$`);
}
function Oh(e) {
  let t = `${pu}T${yu(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function kh(e, t) {
  return !!((t === "v4" || !t) && Ah.test(e) || (t === "v6" || !t) && Eh.test(e));
}
function Ph(e, t) {
  if (!gh.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || "typ" in a && a?.typ !== "JWT" || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function qh(e, t) {
  return !!((t === "v4" || !t) && Th.test(e) || (t === "v6" || !t) && Rh.test(e));
}
class be extends O {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== v.string) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.string,
        received: s.parsedType
      }), T;
    }
    const n = new te();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), y(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), y(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, o = t.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(t, a), i ? y(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && y(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        bh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "email",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        Oa || (Oa = new RegExp(Sh, "u")), Oa.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "emoji",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        mh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "uuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        vh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "nanoid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        hh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "cuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        ph.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "cuid2",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        yh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "ulid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), y(a, {
            validation: "url",
            code: p.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "regex",
        code: p.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Oh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Ih.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? xh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? _h.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "duration",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? kh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "ip",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? Ph(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "jwt",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? qh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "cidr",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? wh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "base64",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? Ch.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "base64url",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : q.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: p.invalid_string,
      ...g.errToObj(n)
    });
  }
  _addCheck(t) {
    return new be({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...g.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...g.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...g.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...g.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...g.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...g.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...g.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...g.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...g.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...g.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...g.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...g.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...g.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      offset: t?.offset ?? !1,
      local: t?.local ?? !1,
      ...g.errToObj(t?.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      ...g.errToObj(t?.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...g.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...g.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r?.position,
      ...g.errToObj(r?.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...g.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...g.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...g.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...g.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...g.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, g.errToObj(t));
  }
  trim() {
    return new be({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new be({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new be({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
be.create = (e) => new be({
  checks: [],
  typeName: A.ZodString,
  coerce: e?.coerce ?? !1,
  ...w(e)
});
function Vh(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = Number.parseInt(e.toFixed(a).replace(".", "")), i = Number.parseInt(t.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class ut extends O {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== v.number) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.number,
        received: s.parsedType
      }), T;
    }
    let n;
    const a = new te();
    for (const s of this._def.checks)
      s.kind === "int" ? q.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? Vh(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_finite,
        message: s.message
      }), a.dirty()) : q.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, g.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, g.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, g.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, g.toString(r));
  }
  setLimit(t, r, n, a) {
    return new ut({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: g.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: g.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: g.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: g.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: g.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: g.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: g.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: g.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: g.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && q.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
ut.create = (e) => new ut({
  checks: [],
  typeName: A.ZodNumber,
  coerce: e?.coerce || !1,
  ...w(e)
});
class Rt extends O {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== v.bigint)
      return this._getInvalidInput(t);
    let n;
    const a = new te();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : q.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return y(r, {
      code: p.invalid_type,
      expected: v.bigint,
      received: r.parsedType
    }), T;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, g.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, g.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, g.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, g.toString(r));
  }
  setLimit(t, r, n, a) {
    return new Rt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Rt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: g.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Rt.create = (e) => new Rt({
  checks: [],
  typeName: A.ZodBigInt,
  coerce: e?.coerce ?? !1,
  ...w(e)
});
class Qa extends O {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== v.boolean) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.boolean,
        received: n.parsedType
      }), T;
    }
    return oe(t.data);
  }
}
Qa.create = (e) => new Qa({
  typeName: A.ZodBoolean,
  coerce: e?.coerce || !1,
  ...w(e)
});
class Ft extends O {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== v.date) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.date,
        received: s.parsedType
      }), T;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_date
      }), T;
    }
    const n = new te();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : q.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Ft({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: g.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: g.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
Ft.create = (e) => new Ft({
  checks: [],
  coerce: e?.coerce || !1,
  typeName: A.ZodDate,
  ...w(e)
});
class cc extends O {
  _parse(t) {
    if (this._getType(t) !== v.symbol) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.symbol,
        received: n.parsedType
      }), T;
    }
    return oe(t.data);
  }
}
cc.create = (e) => new cc({
  typeName: A.ZodSymbol,
  ...w(e)
});
class Ya extends O {
  _parse(t) {
    if (this._getType(t) !== v.undefined) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.undefined,
        received: n.parsedType
      }), T;
    }
    return oe(t.data);
  }
}
Ya.create = (e) => new Ya({
  typeName: A.ZodUndefined,
  ...w(e)
});
class Xa extends O {
  _parse(t) {
    if (this._getType(t) !== v.null) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.null,
        received: n.parsedType
      }), T;
    }
    return oe(t.data);
  }
}
Xa.create = (e) => new Xa({
  typeName: A.ZodNull,
  ...w(e)
});
class wt extends O {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return oe(t.data);
  }
}
wt.create = (e) => new wt({
  typeName: A.ZodAny,
  ...w(e)
});
class uc extends O {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return oe(t.data);
  }
}
uc.create = (e) => new uc({
  typeName: A.ZodUnknown,
  ...w(e)
});
class Ce extends O {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return y(r, {
      code: p.invalid_type,
      expected: v.never,
      received: r.parsedType
    }), T;
  }
}
Ce.create = (e) => new Ce({
  typeName: A.ZodNever,
  ...w(e)
});
class lc extends O {
  _parse(t) {
    if (this._getType(t) !== v.undefined) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.void,
        received: n.parsedType
      }), T;
    }
    return oe(t.data);
  }
}
lc.create = (e) => new lc({
  typeName: A.ZodVoid,
  ...w(e)
});
class le extends O {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== v.array)
      return y(r, {
        code: p.invalid_type,
        expected: v.array,
        received: r.parsedType
      }), T;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (y(r, {
        code: i ? p.too_big : p.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (y(r, {
      code: p.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (y(r, {
      code: p.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new de(r, i, r.path, o)))).then((i) => te.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new de(r, i, r.path, o)));
    return te.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new le({
      ...this._def,
      minLength: { value: t, message: g.toString(r) }
    });
  }
  max(t, r) {
    return new le({
      ...this._def,
      maxLength: { value: t, message: g.toString(r) }
    });
  }
  length(t, r) {
    return new le({
      ...this._def,
      exactLength: { value: t, message: g.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
le.create = (e, t) => new le({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: A.ZodArray,
  ...w(t)
});
function st(e) {
  if (e instanceof Z) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = Se.create(st(n));
    }
    return new Z({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof le ? new le({
    ...e._def,
    type: st(e.element)
  }) : e instanceof Se ? Se.create(st(e.unwrap())) : e instanceof Ge ? Ge.create(st(e.unwrap())) : e instanceof Ue ? Ue.create(e.items.map((t) => st(t))) : e;
}
class Z extends O {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = q.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== v.object) {
      const l = this._getOrReturnCtx(t);
      return y(l, {
        code: p.invalid_type,
        expected: v.object,
        received: l.parsedType
      }), T;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Ce && this._def.unknownKeys === "strip"))
      for (const l in a.data)
        i.includes(l) || o.push(l);
    const u = [];
    for (const l of i) {
      const h = s[l], m = a.data[l];
      u.push({
        key: { status: "valid", value: l },
        value: h._parse(new de(a, m, a.path, l)),
        alwaysSet: l in a.data
      });
    }
    if (this._def.catchall instanceof Ce) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const h of o)
          u.push({
            key: { status: "valid", value: h },
            value: { status: "valid", value: a.data[h] }
          });
      else if (l === "strict")
        o.length > 0 && (y(a, {
          code: p.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const h of o) {
        const m = a.data[h];
        u.push({
          key: { status: "valid", value: h },
          value: l._parse(
            new de(a, m, a.path, h)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: h in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const h of u) {
        const m = await h.key, R = await h.value;
        l.push({
          key: m,
          value: R,
          alwaysSet: h.alwaysSet
        });
      }
      return l;
    }).then((l) => te.mergeObjectSync(n, l)) : te.mergeObjectSync(n, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return g.errToObj, new Z({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          const a = this._def.errorMap?.(r, n).message ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: g.errToObj(t).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new Z({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Z({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Z({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Z({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: A.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Z({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of q.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of q.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return st(this);
  }
  partial(t) {
    const r = {};
    for (const n of q.objectKeys(this.shape)) {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of q.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof Se; )
          s = s._def.innerType;
        r[n] = s;
      }
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return mu(q.objectKeys(this.shape));
  }
}
Z.create = (e, t) => new Z({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: A.ZodObject,
  ...w(t)
});
Z.strictCreate = (e, t) => new Z({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Ce.create(),
  typeName: A.ZodObject,
  ...w(t)
});
Z.lazycreate = (e, t) => new Z({
  shape: e,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: A.ZodObject,
  ...w(t)
});
class Zt extends O {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Ae(o.ctx.common.issues));
      return y(r, {
        code: p.invalid_union,
        unionErrors: i
      }), T;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const u of n) {
        const l = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, h = u._parseSync({
          data: r.data,
          path: r.path,
          parent: l
        });
        if (h.status === "valid")
          return h;
        h.status === "dirty" && !s && (s = { result: h, ctx: l }), l.common.issues.length && i.push(l.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((u) => new Ae(u));
      return y(r, {
        code: p.invalid_union,
        unionErrors: o
      }), T;
    }
  }
  get options() {
    return this._def.options;
  }
}
Zt.create = (e, t) => new Zt({
  options: e,
  typeName: A.ZodUnion,
  ...w(t)
});
const _e = (e) => e instanceof zt ? _e(e.schema) : e instanceof Be ? _e(e.innerType()) : e instanceof Qt ? [e.value] : e instanceof Ke ? e.options : e instanceof ts ? q.objectValues(e.enum) : e instanceof Xt ? _e(e._def.innerType) : e instanceof Ya ? [void 0] : e instanceof Xa ? [null] : e instanceof Se ? [void 0, ..._e(e.unwrap())] : e instanceof Ge ? [null, ..._e(e.unwrap())] : e instanceof vu || e instanceof tr ? _e(e.unwrap()) : e instanceof er ? _e(e._def.innerType) : [];
class gs extends O {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== v.object)
      return y(r, {
        code: p.invalid_type,
        expected: v.object,
        received: r.parsedType
      }), T;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (y(r, {
      code: p.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), T);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = _e(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new gs({
      typeName: A.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...w(n)
    });
  }
}
function es(e, t) {
  const r = Re(e), n = Re(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === v.object && n === v.object) {
    const a = q.objectKeys(t), s = q.objectKeys(e).filter((o) => a.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of s) {
      const u = es(e[o], t[o]);
      if (!u.valid)
        return { valid: !1 };
      i[o] = u.data;
    }
    return { valid: !0, data: i };
  } else if (r === v.array && n === v.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], o = t[s], u = es(i, o);
      if (!u.valid)
        return { valid: !1 };
      a.push(u.data);
    }
    return { valid: !0, data: a };
  } else return r === v.date && n === v.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Wt extends O {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, i) => {
      if (sc(s) || sc(i))
        return T;
      const o = es(s.value, i.value);
      return o.valid ? ((ic(s) || ic(i)) && r.dirty(), { status: r.value, value: o.data }) : (y(n, {
        code: p.invalid_intersection_types
      }), T);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Wt.create = (e, t, r) => new Wt({
  left: e,
  right: t,
  typeName: A.ZodIntersection,
  ...w(r)
});
class Ue extends O {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.array)
      return y(n, {
        code: p.invalid_type,
        expected: v.array,
        received: n.parsedType
      }), T;
    if (n.data.length < this._def.items.length)
      return y(n, {
        code: p.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), T;
    !this._def.rest && n.data.length > this._def.items.length && (y(n, {
      code: p.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const u = this._def.items[o] || this._def.rest;
      return u ? u._parse(new de(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => te.mergeArray(r, i)) : te.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Ue({
      ...this._def,
      rest: t
    });
  }
}
Ue.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ue({
    items: e,
    typeName: A.ZodTuple,
    rest: null,
    ...w(t)
  });
};
class Jt extends O {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.object)
      return y(n, {
        code: p.invalid_type,
        expected: v.object,
        received: n.parsedType
      }), T;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new de(n, o, n.path, o)),
        value: i._parse(new de(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? te.mergeObjectAsync(r, a) : te.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof O ? new Jt({
      keyType: t,
      valueType: r,
      typeName: A.ZodRecord,
      ...w(n)
    }) : new Jt({
      keyType: be.create(),
      valueType: t,
      typeName: A.ZodRecord,
      ...w(r)
    });
  }
}
class dc extends O {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.map)
      return y(n, {
        code: p.invalid_type,
        expected: v.map,
        received: n.parsedType
      }), T;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, u], l) => ({
      key: a._parse(new de(n, o, n.path, [l, "key"])),
      value: s._parse(new de(n, u, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const l = await u.key, h = await u.value;
          if (l.status === "aborted" || h.status === "aborted")
            return T;
          (l.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(l.value, h.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const u of i) {
        const l = u.key, h = u.value;
        if (l.status === "aborted" || h.status === "aborted")
          return T;
        (l.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(l.value, h.value);
      }
      return { status: r.value, value: o };
    }
  }
}
dc.create = (e, t, r) => new dc({
  valueType: t,
  keyType: e,
  typeName: A.ZodMap,
  ...w(r)
});
class Ct extends O {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.set)
      return y(n, {
        code: p.invalid_type,
        expected: v.set,
        received: n.parsedType
      }), T;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (y(n, {
      code: p.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (y(n, {
      code: p.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(u) {
      const l = /* @__PURE__ */ new Set();
      for (const h of u) {
        if (h.status === "aborted")
          return T;
        h.status === "dirty" && r.dirty(), l.add(h.value);
      }
      return { status: r.value, value: l };
    }
    const o = [...n.data.values()].map((u, l) => s._parse(new de(n, u, n.path, l)));
    return n.common.async ? Promise.all(o).then((u) => i(u)) : i(o);
  }
  min(t, r) {
    return new Ct({
      ...this._def,
      minSize: { value: t, message: g.toString(r) }
    });
  }
  max(t, r) {
    return new Ct({
      ...this._def,
      maxSize: { value: t, message: g.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Ct.create = (e, t) => new Ct({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: A.ZodSet,
  ...w(t)
});
class zt extends O {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
zt.create = (e, t) => new zt({
  getter: e,
  typeName: A.ZodLazy,
  ...w(t)
});
class Qt extends O {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return y(r, {
        received: r.data,
        code: p.invalid_literal,
        expected: this._def.value
      }), T;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Qt.create = (e, t) => new Qt({
  value: e,
  typeName: A.ZodLiteral,
  ...w(t)
});
function mu(e, t) {
  return new Ke({
    values: e,
    typeName: A.ZodEnum,
    ...w(t)
  });
}
class Ke extends O {
  constructor() {
    super(...arguments), Tt.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return y(r, {
        expected: q.joinValues(n),
        received: r.parsedType,
        code: p.invalid_type
      }), T;
    }
    if (Gt(this, Tt, "f") || hu(this, Tt, new Set(this._def.values), "f"), !Gt(this, Tt, "f").has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return y(r, {
        received: r.data,
        code: p.invalid_enum_value,
        options: n
      }), T;
    }
    return oe(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Ke.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Ke.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Tt = /* @__PURE__ */ new WeakMap();
Ke.create = mu;
class ts extends O {
  constructor() {
    super(...arguments), Et.set(this, void 0);
  }
  _parse(t) {
    const r = q.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== v.string && n.parsedType !== v.number) {
      const a = q.objectValues(r);
      return y(n, {
        expected: q.joinValues(a),
        received: n.parsedType,
        code: p.invalid_type
      }), T;
    }
    if (Gt(this, Et, "f") || hu(this, Et, new Set(q.getValidEnumValues(this._def.values)), "f"), !Gt(this, Et, "f").has(t.data)) {
      const a = q.objectValues(r);
      return y(n, {
        received: n.data,
        code: p.invalid_enum_value,
        options: a
      }), T;
    }
    return oe(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Et = /* @__PURE__ */ new WeakMap();
ts.create = (e, t) => new ts({
  values: e,
  typeName: A.ZodNativeEnum,
  ...w(t)
});
class Yt extends O {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== v.promise && r.common.async === !1)
      return y(r, {
        code: p.invalid_type,
        expected: v.promise,
        received: r.parsedType
      }), T;
    const n = r.parsedType === v.promise ? r.data : Promise.resolve(r.data);
    return oe(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
Yt.create = (e, t) => new Yt({
  type: e,
  typeName: A.ZodPromise,
  ...w(t)
});
class Be extends O {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === A.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        y(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return T;
          const u = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return u.status === "aborted" ? T : u.status === "dirty" || r.value === "dirty" ? At(u.value) : u;
        });
      {
        if (r.value === "aborted")
          return T;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? T : o.status === "dirty" || r.value === "dirty" ? At(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const u = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? T : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? T : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!ct(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => ct(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    q.assertNever(a);
  }
}
Be.create = (e, t, r) => new Be({
  schema: e,
  typeName: A.ZodEffects,
  effect: t,
  ...w(r)
});
Be.createWithPreprocess = (e, t, r) => new Be({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: A.ZodEffects,
  ...w(r)
});
class Se extends O {
  _parse(t) {
    return this._getType(t) === v.undefined ? oe(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Se.create = (e, t) => new Se({
  innerType: e,
  typeName: A.ZodOptional,
  ...w(t)
});
class Ge extends O {
  _parse(t) {
    return this._getType(t) === v.null ? oe(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ge.create = (e, t) => new Ge({
  innerType: e,
  typeName: A.ZodNullable,
  ...w(t)
});
class Xt extends O {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === v.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Xt.create = (e, t) => new Xt({
  innerType: e,
  typeName: A.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...w(t)
});
class er extends O {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Bt(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Ae(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Ae(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
er.create = (e, t) => new er({
  innerType: e,
  typeName: A.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...w(t)
});
class fc extends O {
  _parse(t) {
    if (this._getType(t) !== v.nan) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.nan,
        received: n.parsedType
      }), T;
    }
    return { status: "valid", value: t.data };
  }
}
fc.create = (e) => new fc({
  typeName: A.ZodNaN,
  ...w(e)
});
class vu extends O {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class _s extends O {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? T : s.status === "dirty" ? (r.dirty(), At(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? T : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new _s({
      in: t,
      out: r,
      typeName: A.ZodPipeline
    });
  }
}
class tr extends O {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (ct(a) && (a.value = Object.freeze(a.value)), a);
    return Bt(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
tr.create = (e, t) => new tr({
  innerType: e,
  typeName: A.ZodReadonly,
  ...w(t)
});
function hc(e, t) {
  const r = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof r == "string" ? { message: r } : r;
}
function bs(e, t = {}, r) {
  return e ? wt.create().superRefine((n, a) => {
    const s = e(n);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const o = hc(t, n), u = o.fatal ?? r ?? !0;
          a.addIssue({ code: "custom", ...o, fatal: u });
        }
      });
    if (!s) {
      const i = hc(t, n), o = i.fatal ?? r ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : wt.create();
}
var A;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(A || (A = {}));
const pr = (e, t = {
  message: `Input not instance of ${e.name}`
}) => bs((r) => r instanceof e, t), c = be.create, Ze = ut.create, E = Qa.create;
wt.create;
Ce.create;
const b = le.create, f = Z.create, L = Zt.create, K = gs.create;
Wt.create;
Ue.create;
const Mh = Jt.create, se = zt.create, d = Qt.create, ee = Ke.create;
Yt.create;
const ie = Se.create;
Ge.create;
var _ = (e) => e, Nh = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null) return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Type guard that checks if data is valid for any version up to and including the specified version.
   * 
   * @param data The data to check
   * @param upToVersion The maximum version to check against (inclusive)
   * @returns true if the data is valid for any version from 1 to upToVersion,
   *          false if the data's version is higher than upToVersion or invalid
   * 
   * @example
   * ```ts
   * const entity = createVersionedEntity({ ... })
   * 
   * if (entity.isUpToVersion(data, 2)) {
   *   // data is guaranteed to be v1 or v2 (but not v3 or higher)
   * }
   * 
   * // Returns false for v3 data when checking up to v2
   * entity.isUpToVersion(v3Data, 2) // false
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions where you want to ensure
   * nested entities are at a specific version or lower.
   */
  isUpToVersion(e, t) {
    let r = this.getVersion(e);
    if (r === null || r > t) return !1;
    const n = this.versionMap[r];
    return n ? n.schema.safeParse(e).success : !1;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let a = n.data;
    for (let s = t + 1; s <= this.latestVersion; s++) {
      const i = this.versionMap[s];
      if (!i)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (i.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = i.up(a);
    }
    return { type: "ok", value: a };
  }
  /**
   * Returns the Zod schema for the latest version of the entity.
   * 
   * @example
   * ```ts
   * const UserEntity = createVersionedEntity({ ... })
   * const latestSchema = UserEntity.latestSchema
   * ```
   */
  get latestSchema() {
    return this.versionMap[this.latestVersion].schema;
  }
  /**
   * Parses data and migrates it up to a specific version (not beyond).
   * 
   * @param data The data to parse and potentially migrate
   * @param version The target version to migrate to (will not migrate beyond this)
   * @returns A ParseResult containing either the migrated data or an error.
   *          Returns { type: "err", error: { type: "INVALID_VER" } } if data version is higher than requested.
   * 
   * @example
   * ```ts
   * // If you have v1 data and versions up to v4 exist:
   * const result = entity.safeParseUpToVersion(v1Data, 2)
   * // result will contain v2 data (not v3 or v4)
   * 
   * // Trying to parse v3 data up to v2 returns an error
   * const result = entity.safeParseUpToVersion(v3Data, 2)
   * // result: { type: "err", error: { type: "INVALID_VER" } }
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions to prevent migration
   * functions from receiving future versions they weren't designed to handle.
   */
  safeParseUpToVersion(e, t) {
    const r = this.getVersion(e);
    if (r === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    if (r > t)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = this.versionMap[r];
    if (!n)
      return { type: "err", error: { type: "INVALID_VER" } };
    const a = n.schema.safeParse(e);
    if (!a.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: r,
          versionDef: n,
          error: a.error
        }
      };
    let s = a.data;
    for (let i = r + 1; i <= t; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function We(e) {
  return new Nh(e.versionMap, e.latestVersion, e.getVersion);
}
function lt(e) {
  return bs((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
function ce(e, t) {
  return bs((r) => e.isUpToVersion(r, t)).transform((r) => {
    const n = e.safeParseUpToVersion(r, t);
    if (n.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.isUpToVersion` returned success, safeParse failed."
      );
    return n.value;
  });
}
var ka, pc;
function $h() {
  if (pc) return ka;
  pc = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return ka = t, ka;
}
var Pa, yc;
function Dh() {
  if (yc) return Pa;
  yc = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Pa = e, Pa;
}
var qa, mc;
function jh() {
  if (mc) return qa;
  mc = 1;
  var e = Qc(), t = $h(), r = Dh();
  function n(a) {
    var s = -1, i = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++s < i; )
      this.add(a[s]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, qa = n, qa;
}
var Va, vc;
function Hh() {
  if (vc) return Va;
  vc = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Va = e, Va;
}
var Ma, gc;
function Lh() {
  if (gc) return Ma;
  gc = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Ma = e, Ma;
}
var Na, _c;
function gu() {
  if (_c) return Na;
  _c = 1;
  var e = jh(), t = Hh(), r = Lh(), n = 1, a = 2;
  function s(i, o, u, l, h, m) {
    var R = u & n, N = i.length, U = o.length;
    if (N != U && !(R && U > N))
      return !1;
    var D = m.get(i), M = m.get(o);
    if (D && M)
      return D == o && M == i;
    var V = -1, C = !0, B = u & a ? new e() : void 0;
    for (m.set(i, o), m.set(o, i); ++V < N; ) {
      var k = i[V], G = o[V];
      if (l)
        var P = R ? l(G, k, V, o, i, m) : l(k, G, V, i, o, m);
      if (P !== void 0) {
        if (P)
          continue;
        C = !1;
        break;
      }
      if (B) {
        if (!t(o, function(x, W) {
          if (!r(B, W) && (k === x || h(k, x, u, l, m)))
            return B.push(W);
        })) {
          C = !1;
          break;
        }
      } else if (!(k === G || h(k, G, u, l, m))) {
        C = !1;
        break;
      }
    }
    return m.delete(i), m.delete(o), C;
  }
  return Na = s, Na;
}
var $a, bc;
function Uh() {
  if (bc) return $a;
  bc = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, s) {
      n[++r] = [s, a];
    }), n;
  }
  return $a = e, $a;
}
var Da, Sc;
function Kh() {
  if (Sc) return Da;
  Sc = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return Da = e, Da;
}
var ja, Ac;
function Bh() {
  if (Ac) return ja;
  Ac = 1;
  var e = or(), t = fu(), r = cs(), n = gu(), a = Uh(), s = Kh(), i = 1, o = 2, u = "[object Boolean]", l = "[object Date]", h = "[object Error]", m = "[object Map]", R = "[object Number]", N = "[object RegExp]", U = "[object Set]", D = "[object String]", M = "[object Symbol]", V = "[object ArrayBuffer]", C = "[object DataView]", B = e ? e.prototype : void 0, k = B ? B.valueOf : void 0;
  function G(P, x, W, j, re, I, X) {
    switch (W) {
      case C:
        if (P.byteLength != x.byteLength || P.byteOffset != x.byteOffset)
          return !1;
        P = P.buffer, x = x.buffer;
      case V:
        return !(P.byteLength != x.byteLength || !I(new t(P), new t(x)));
      case u:
      case l:
      case R:
        return r(+P, +x);
      case h:
        return P.name == x.name && P.message == x.message;
      case N:
      case D:
        return P == x + "";
      case m:
        var ae = a;
      case U:
        var Ye = j & i;
        if (ae || (ae = s), P.size != x.size && !Ye)
          return !1;
        var Xe = X.get(P);
        if (Xe)
          return Xe == x;
        j |= o, X.set(P, x);
        var Or = n(ae(P), ae(x), j, re, I, X);
        return X.delete(P), Or;
      case M:
        if (k)
          return k.call(P) == k.call(x);
    }
    return !1;
  }
  return ja = G, ja;
}
var Ha, Tc;
function Gh() {
  if (Tc) return Ha;
  Tc = 1;
  var e = du(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o, u, l, h) {
    var m = o & t, R = e(s), N = R.length, U = e(i), D = U.length;
    if (N != D && !m)
      return !1;
    for (var M = N; M--; ) {
      var V = R[M];
      if (!(m ? V in i : n.call(i, V)))
        return !1;
    }
    var C = h.get(s), B = h.get(i);
    if (C && B)
      return C == i && B == s;
    var k = !0;
    h.set(s, i), h.set(i, s);
    for (var G = m; ++M < N; ) {
      V = R[M];
      var P = s[V], x = i[V];
      if (u)
        var W = m ? u(x, P, V, i, s, h) : u(P, x, V, s, i, h);
      if (!(W === void 0 ? P === x || l(P, x, o, u, h) : W)) {
        k = !1;
        break;
      }
      G || (G = V == "constructor");
    }
    if (k && !G) {
      var j = s.constructor, re = i.constructor;
      j != re && "constructor" in s && "constructor" in i && !(typeof j == "function" && j instanceof j && typeof re == "function" && re instanceof re) && (k = !1);
    }
    return h.delete(s), h.delete(i), k;
  }
  return Ha = a, Ha;
}
var La, Ec;
function Fh() {
  if (Ec) return La;
  Ec = 1;
  var e = Yc(), t = gu(), r = Bh(), n = Gh(), a = hr(), s = fr(), i = ls(), o = ru(), u = 1, l = "[object Arguments]", h = "[object Array]", m = "[object Object]", R = Object.prototype, N = R.hasOwnProperty;
  function U(D, M, V, C, B, k) {
    var G = s(D), P = s(M), x = G ? h : a(D), W = P ? h : a(M);
    x = x == l ? m : x, W = W == l ? m : W;
    var j = x == m, re = W == m, I = x == W;
    if (I && i(D)) {
      if (!i(M))
        return !1;
      G = !0, j = !1;
    }
    if (I && !j)
      return k || (k = new e()), G || o(D) ? t(D, M, V, C, B, k) : r(D, M, x, V, C, B, k);
    if (!(V & u)) {
      var X = j && N.call(D, "__wrapped__"), ae = re && N.call(M, "__wrapped__");
      if (X || ae) {
        var Ye = X ? D.value() : D, Xe = ae ? M.value() : M;
        return k || (k = new e()), B(Ye, Xe, V, C, k);
      }
    }
    return I ? (k || (k = new e()), n(D, M, V, C, B, k)) : !1;
  }
  return La = U, La;
}
var Ua, Rc;
function Zh() {
  if (Rc) return Ua;
  Rc = 1;
  var e = Fh(), t = yt();
  function r(n, a, s, i, o) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, s, i, r, o);
  }
  return Ua = r, Ua;
}
var Ka, wc;
function Wh() {
  if (wc) return Ka;
  wc = 1;
  var e = Zh();
  function t(r, n) {
    return e(r, n);
  }
  return Ka = t, Ka;
}
var Jh = Wh();
const zh = /* @__PURE__ */ Zc(Jh), Cc = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), Ba = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), De = {
  equals(e, t) {
    return zh(e, t);
  }
}, Qh = f({
  id: ie(c()),
  // Firebase Firestore ID
  url: c(),
  path: c(),
  headers: b(
    f({
      key: c(),
      value: c(),
      active: E()
    })
  ),
  params: b(
    f({
      key: c(),
      value: c(),
      active: E()
    })
  ),
  name: c(),
  method: c(),
  preRequestScript: c(),
  testScript: c(),
  contentType: c(),
  body: c(),
  rawParams: ie(c()),
  auth: ie(c()),
  httpUser: ie(c()),
  httpPassword: ie(c()),
  bearerToken: ie(c())
}), Ic = _({
  initial: !0,
  schema: Qh
}), Ss = f({
  key: c(),
  active: E()
}).and(
  L([
    f({
      isFile: d(!0),
      value: b(pr(Blob).nullable())
    }),
    f({
      isFile: d(!1),
      value: c()
    })
  ])
);
f({
  contentType: d("multipart/form-data"),
  body: b(Ss)
});
const Yh = L([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Ss).catch([])
  }),
  f({
    contentType: L([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: c().catch("")
  })
]), pe = f({
  authType: d("none")
}), ye = f({
  authType: d("basic"),
  username: c().catch(""),
  password: c().catch("")
}), me = f({
  authType: d("bearer"),
  token: c().catch("")
}), Xh = f({
  authType: d("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), As = f({
  authType: d("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), ve = f({
  authType: d("inherit")
}), ep = K("authType", [
  pe,
  ve,
  ye,
  me,
  Xh,
  As
]).and(
  f({
    authActive: E()
  })
), tp = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0)
  })
), _u = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0)
  })
), bu = f({
  v: d("1"),
  id: ie(c()),
  // Firebase Firestore ID
  name: c(),
  method: c(),
  endpoint: c(),
  params: tp,
  headers: _u,
  preRequestScript: c().catch(""),
  testScript: c().catch(""),
  auth: ep,
  body: Yh
});
function rp(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function np(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const ap = _({
  initial: !1,
  schema: bu,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: u
    } = e, l = `${t}${r}`, h = rp(e), m = np(e), R = {
      v: "1",
      endpoint: l,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: u,
      body: h,
      auth: m
    };
    return e.id && (R.id = e.id), R;
  }
}), Ts = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0)
  })
), Su = bu.extend({
  v: d("2"),
  requestVariables: Ts
}), sp = _({
  initial: !1,
  schema: Su,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), Au = f({
  grantType: d("AUTHORIZATION_CODE"),
  authEndpoint: c().trim(),
  tokenEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch(""),
  isPKCE: E(),
  codeVerifierMethod: L([d("plain"), d("S256")]).optional()
}), yr = f({
  grantType: d("CLIENT_CREDENTIALS"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), mr = f({
  grantType: d("PASSWORD"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  username: c().trim(),
  password: c().trim(),
  token: c().catch("")
}), mt = f({
  grantType: d("IMPLICIT"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), vr = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Au,
    yr,
    mr,
    mt
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), ip = K("authType", [
  pe,
  ve,
  ye,
  me,
  vr,
  As
]).and(
  f({
    authActive: E()
  })
), Tu = Su.extend({
  v: d("3"),
  auth: ip
}), op = _({
  initial: !1,
  schema: Tu,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), Oe = As.extend({
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), cp = K("authType", [
  pe,
  ve,
  ye,
  me,
  vr,
  Oe
]).and(
  f({
    authActive: E()
  })
), Eu = Tu.extend({
  v: d("4"),
  auth: cp
}), up = _({
  schema: Eu,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), Ru = Au.extend({
  clientSecret: c().optional()
}), gr = vr.extend({
  grantTypeInfo: K("grantType", [
    Ru,
    yr,
    mr,
    mt
  ])
}), wu = K("authType", [
  pe,
  ve,
  ye,
  me,
  gr,
  Oe
]).and(
  f({
    authActive: E()
  })
), Cu = Eu.extend({
  v: d("5"),
  auth: wu
}), lp = _({
  schema: Cu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Iu = L([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Ss).catch([])
  }),
  f({
    contentType: L([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: c().catch("")
  })
]), xu = Cu.extend({
  v: d("6"),
  body: Iu
}), dp = _({
  schema: xu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), _r = Ru.extend({
  refreshToken: c().optional()
}), Ou = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    _r,
    yr,
    mr,
    mt
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Es = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0),
    description: c().catch("")
  })
), br = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0),
    description: c().catch("")
  })
), Je = f({
  authType: d("aws-signature"),
  accessKey: c().catch(""),
  secretKey: c().catch(""),
  region: c().catch(""),
  serviceName: c().catch(""),
  serviceToken: c().optional(),
  signature: f({}).optional(),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), ku = K("authType", [
  pe,
  ve,
  ye,
  me,
  Ou,
  Oe,
  Je
]).and(
  f({
    authActive: E()
  })
), Pu = xu.extend({
  v: d("7"),
  params: Es,
  headers: br,
  auth: ku
}), fp = _({
  schema: Pu,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: ""
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), qu = yr.extend({
  clientSecret: c().optional()
}), Rs = mr.extend({
  clientSecret: c().optional()
}), hp = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    _r,
    qu,
    Rs,
    mt
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ot = f({
  authType: d("digest"),
  username: c().catch(""),
  password: c().catch(""),
  realm: c().catch(""),
  nonce: c().catch(""),
  algorithm: ee(["MD5", "MD5-sess"]).catch("MD5"),
  qop: ee(["auth", "auth-int"]).catch("auth"),
  nc: c().catch(""),
  cnonce: c().catch(""),
  opaque: c().catch(""),
  disableRetry: E().catch(!1)
}), ws = K("authType", [
  pe,
  ve,
  ye,
  me,
  hp,
  Oe,
  Je,
  Ot
]).and(
  f({
    authActive: E()
  })
), Vu = f({
  v: d("1"),
  name: c(),
  method: c(),
  endpoint: c(),
  headers: br,
  params: Es,
  body: Iu,
  auth: ws,
  requestVariables: Ts
}), xc = _({
  initial: !0,
  schema: Vu
}), Mu = f({
  key: c(),
  active: E(),
  contentType: c().optional().catch(void 0)
}).and(
  L([
    f({
      isFile: d(!0),
      value: b(pr(Blob).nullable()).catch([])
    }),
    f({
      isFile: d(!1),
      value: c()
    })
  ])
).transform((e) => e.isFile && Array.isArray(e.value) && e.value.length === 0 ? {
  ...e,
  isFile: !1,
  value: ""
} : e), Nu = L([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Mu).catch([]),
    showIndividualContentType: E().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: pr(File).nullable().catch(null)
  }),
  f({
    contentType: L([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: c().catch("")
  })
]), $u = Vu.extend({
  v: d("2"),
  body: Nu
}), pp = _({
  initial: !1,
  schema: $u,
  up(e) {
    return {
      ...e,
      v: "2"
    };
  }
}), Du = qu.extend({
  clientAuthentication: ee(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), Sr = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    _r,
    Du,
    Rs,
    mt
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Cs = K("authType", [
  pe,
  ve,
  ye,
  me,
  Sr,
  Oe,
  Je,
  Ot
]).and(
  f({
    authActive: E()
  })
), Is = L([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Mu).catch([]),
    showIndividualContentType: E().optional().catch(!1),
    isBulkEditing: E().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: pr(File).nullable().catch(null)
  }),
  f({
    contentType: d("application/x-www-form-urlencoded"),
    body: c().catch(""),
    isBulkEditing: E().optional().catch(!1)
  }),
  f({
    contentType: L([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: c().catch("")
  })
]), ju = $u.extend({
  v: d("3"),
  auth: Cs,
  body: Is
}), yp = _({
  initial: !1,
  schema: ju,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "3",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), xs = f({
  authType: d("hawk"),
  authId: c().catch(""),
  authKey: c().catch(""),
  algorithm: ee(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: E().catch(!1),
  // Optional fields
  user: c().optional(),
  nonce: c().optional(),
  ext: c().optional(),
  app: c().optional(),
  dlg: c().optional(),
  timestamp: c().optional()
}), Os = f({
  authType: d("akamai-eg"),
  accessToken: c().catch(""),
  clientToken: c().catch(""),
  clientSecret: c().catch(""),
  // Optional fields
  nonce: c().optional(),
  timestamp: c().optional(),
  host: c().optional(),
  headersToSign: c().optional(),
  maxBodySize: c().optional()
}), ks = K("authType", [
  pe,
  ve,
  ye,
  me,
  Sr,
  Oe,
  Je,
  Ot,
  xs,
  Os
]).and(
  f({
    authActive: E()
  })
), Hu = ju.extend({
  v: d("4"),
  auth: ks
}), mp = _({
  initial: !1,
  schema: Hu,
  up(e) {
    return {
      ...e,
      v: "4"
    };
  }
}), Lu = f({
  authType: d("jwt"),
  secret: c().catch(""),
  privateKey: c().catch(""),
  // For RSA/ECDSA algorithms
  algorithm: ee([
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
  ]).catch("HS256"),
  payload: c().catch("{}"),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS"),
  isSecretBase64Encoded: E().catch(!1),
  headerPrefix: c().catch("Bearer "),
  paramName: c().catch("token"),
  jwtHeaders: c().catch("{}")
}), Ps = K("authType", [
  pe,
  ve,
  ye,
  me,
  Sr,
  Oe,
  Je,
  Ot,
  xs,
  Os,
  Lu
]).and(
  f({
    authActive: E()
  })
), Uu = Hu.extend({
  v: d("5"),
  auth: Ps
}), vp = _({
  initial: !1,
  schema: Uu,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Ie = f({
  id: Ze(),
  key: c(),
  value: c(),
  active: E(),
  sendIn: ee(["headers", "url", "body"]).catch("headers")
}), Ku = Ie.omit({ sendIn: !0 }), gp = _r.extend({
  authRequestParams: b(Ku).optional().default([]),
  tokenRequestParams: b(Ie).optional().default([]),
  refreshRequestParams: b(Ie).optional().default([])
}), _p = Du.extend({
  tokenRequestParams: b(Ie).optional().default([]),
  refreshRequestParams: b(Ie).optional().default([])
}), bp = Rs.extend({
  tokenRequestParams: b(Ie).optional().default([]),
  refreshRequestParams: b(Ie).optional().default([])
}), Sp = mt.extend({
  authRequestParams: b(Ku).optional().default([]),
  refreshRequestParams: b(Ie).optional().default([])
}), Bu = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    gp,
    _p,
    bp,
    Sp
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ar = K("authType", [
  pe,
  ve,
  ye,
  me,
  Bu,
  Oe,
  Je,
  Ot,
  xs,
  Os,
  Lu
]).and(
  f({
    authActive: E()
  })
), Ap = Uu.extend({
  v: d("6"),
  auth: Ar
}), Tp = _({
  initial: !1,
  schema: Ap,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "6",
      auth: t
    };
  }
}), Ep = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), Rp = We({
  latestVersion: 6,
  versionMap: {
    1: xc,
    2: pp,
    3: yp,
    4: mp,
    5: vp,
    6: Tp
  },
  getVersion(e) {
    const t = Ep.safeParse(e);
    return t.success ? t.data.v : xc.schema.safeParse(e).success ? 1 : null;
  }
}), wp = "6", Cp = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, Ip = L(
  Object.keys(Cp).map((e) => d(parseInt(e)))
), xp = b(
  f({
    key: c(),
    value: c()
  })
), Op = f({
  name: c(),
  originalRequest: lt(Rp),
  status: c(),
  code: ie(Ip).nullable().catch(null),
  headers: xp,
  body: c()
}), Oc = _({
  initial: !0,
  schema: Op
}), kp = f({
  v: Ze()
}), Pp = We({
  latestVersion: 0,
  versionMap: {
    0: Oc
  },
  getVersion(e) {
    const t = kp.safeParse(e);
    return t.success ? t.data.v : Oc.schema.safeParse(e).success ? 0 : null;
  }
}), Gu = Mh(
  c(),
  lt(Pp)
);
function eg(e) {
  return {
    v: wp,
    ...e
  };
}
const Fu = Pu.extend({
  v: d("8"),
  auth: ws,
  responses: Gu
}), qp = _({
  schema: Fu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), Zu = Fu.extend({
  v: d("9"),
  body: Nu
}), Vp = _({
  schema: Zu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "9"
    };
  }
}), Wu = Zu.extend({
  v: d("10"),
  body: Is
}), Mp = _({
  schema: Wu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "10"
    };
  }
}), Ju = Wu.extend({
  v: d("11"),
  auth: Cs
}), Np = _({
  schema: Ju,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "11",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), zu = Ju.extend({
  v: d("12"),
  auth: ks
}), $p = _({
  schema: zu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "12"
    };
  }
}), Qu = zu.extend({
  v: d("13"),
  auth: Ps
}), Dp = _({
  schema: Qu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "13"
    };
  }
}), Yu = Qu.extend({
  v: d("14")
}), jp = _({
  schema: Yu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "14"
    };
  }
}), Xu = Yu.extend({
  v: d("15"),
  auth: Ar
}), Hp = _({
  schema: Xu,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "15",
      auth: t
    };
  }
}), Y = [];
for (let e = 0; e < 256; ++e)
  Y.push((e + 256).toString(16).slice(1));
function Lp(e, t = 0) {
  return (Y[e[t + 0]] + Y[e[t + 1]] + Y[e[t + 2]] + Y[e[t + 3]] + "-" + Y[e[t + 4]] + Y[e[t + 5]] + "-" + Y[e[t + 6]] + Y[e[t + 7]] + "-" + Y[e[t + 8]] + Y[e[t + 9]] + "-" + Y[e[t + 10]] + Y[e[t + 11]] + Y[e[t + 12]] + Y[e[t + 13]] + Y[e[t + 14]] + Y[e[t + 15]]).toLowerCase();
}
let Ga;
const Up = new Uint8Array(16);
function Kp() {
  if (!Ga) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Ga = crypto.getRandomValues.bind(crypto);
  }
  return Ga(Up);
}
const Bp = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), kc = { randomUUID: Bp };
function Gp(e, t, r) {
  e = e || {};
  const n = e.random ?? e.rng?.() ?? Kp();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Lp(n);
}
function Fp(e, t, r) {
  return kc.randomUUID && !e ? kc.randomUUID() : Gp(e);
}
const kt = (e = "") => {
  const t = Date.now().toString(36), r = Fp();
  return `${e}_${t}_${r}`;
}, el = Xu.extend({
  v: d("16"),
  _ref_id: c().optional()
}), Zp = _({
  schema: el,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "16",
      _ref_id: e._ref_id ?? kt("req")
    };
  }
}), Wp = el.extend({
  v: d("17"),
  description: c().nullable().catch(null)
}), Jp = _({
  schema: Wp,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "17",
      description: e.description ?? null
    };
  }
}), zp = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, tg = Object.keys(
  zp
), Qp = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), Tr = We({
  latestVersion: 17,
  versionMap: {
    0: Ic,
    1: ap,
    2: sp,
    3: op,
    4: up,
    5: lp,
    6: dp,
    7: fp,
    8: qp,
    9: Vp,
    10: Mp,
    11: Np,
    12: $p,
    13: Dp,
    14: jp,
    15: Hp,
    16: Zp,
    17: Jp
  },
  getVersion(e) {
    const t = Qp.safeParse(e);
    return t.success ? t.data.v : Ic.schema.safeParse(e).success ? 0 : null;
  }
}), Yp = Od({
  id: Cc(ge),
  v: ge,
  auth: De,
  body: De,
  endpoint: ge,
  headers: Ba(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    De
  ),
  params: Ba(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    De
  ),
  method: ge,
  name: ge,
  preRequestScript: ge,
  testScript: ge,
  requestVariables: Ba(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    De
  ),
  responses: De,
  _ref_id: Cc(ge),
  description: De
}), tl = "17", rg = Yp.equals;
function ng(e, t) {
  const r = uh(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "_ref_id" in e && typeof e._ref_id == "string" && (r._ref_id = e._ref_id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = Is.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = Ar.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = Es.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = br.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = Ts.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = Gu.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
    "description" in e && typeof e.description == "string" && (r.description = e.description);
  }
  return r;
}
function ag(e) {
  return {
    v: tl,
    _ref_id: e._ref_id ?? kt("req"),
    ...e
  };
}
function Xp() {
  const e = kt("req");
  return {
    v: tl,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {},
    _ref_id: e,
    description: null
  };
}
function sg(e) {
  return Tr.isLatest(e);
}
function ey(e) {
  const t = Tr.safeParse(e);
  return t.type === "ok" ? t.value : Xp();
}
const qs = f({
  key: c().catch(""),
  value: c().catch(""),
  active: E().catch(!0)
}), ty = f({
  v: d(1),
  name: c(),
  url: c(),
  headers: b(qs).catch([]),
  query: c(),
  variables: c()
}), ry = _({
  initial: !0,
  schema: ty
}), ke = f({
  authType: d("none")
}), Pe = f({
  authType: d("basic"),
  username: c().catch(""),
  password: c().catch("")
}), qe = f({
  authType: d("bearer"),
  token: c().catch("")
}), ny = f({
  authType: d("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), Vs = f({
  authType: d("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), Ve = f({
  authType: d("inherit")
}), ay = K("authType", [
  ke,
  Pe,
  qe,
  ny,
  Vs,
  Ve
]).and(
  f({
    authActive: E()
  })
), rl = f({
  id: ie(c()),
  v: d(2),
  name: c(),
  url: c(),
  headers: b(qs).catch([]),
  query: c(),
  variables: c(),
  auth: ay
}), sy = _({
  initial: !1,
  schema: rl,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), iy = K("authType", [
  ke,
  Ve,
  Pe,
  qe,
  Vs,
  vr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), nl = rl.extend({
  v: d(3),
  auth: iy
}), oy = _({
  initial: !1,
  schema: nl,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), vt = Vs.extend({
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), cy = K("authType", [
  ke,
  Ve,
  Pe,
  qe,
  vt,
  gr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), al = nl.extend({
  v: d(4),
  auth: cy
}), uy = _({
  initial: !1,
  schema: al,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), sl = K("authType", [
  ke,
  Ve,
  Pe,
  qe,
  vt,
  gr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), il = al.extend({
  v: d(5),
  auth: sl
}), ly = _({
  initial: !1,
  schema: il,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), Er = Je, ol = f({
  key: c().catch(""),
  value: c().catch(""),
  active: E().catch(!0),
  description: c().catch("")
}), cl = K("authType", [
  ke,
  Ve,
  Pe,
  qe,
  gr,
  vt,
  Er
]).and(
  f({
    authActive: E()
  })
), ul = il.extend({
  v: d(6),
  auth: cl,
  headers: b(ol).catch([])
}), dy = _({
  schema: ul,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), ll = K("authType", [
  ke,
  Ve,
  Pe,
  qe,
  Ou,
  vt,
  Er
]).and(
  f({
    authActive: E()
  })
), dl = ul.extend({
  v: d(7),
  auth: ll
}), fy = _({
  schema: dl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), Rr = K("authType", [
  ke,
  Ve,
  Pe,
  qe,
  Sr,
  vt,
  Er
]).and(
  f({
    authActive: E()
  })
), fl = dl.extend({
  v: d(8),
  auth: Rr
}), hy = _({
  schema: fl,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: 8,
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), hl = K("authType", [
  ke,
  Ve,
  Pe,
  qe,
  Bu,
  vt,
  Er
]).and(
  f({
    authActive: E()
  })
), py = fl.extend({
  v: d(9),
  auth: hl
}), yy = _({
  schema: py,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t
    };
  }
}), pl = 9, my = f({
  v: Ze()
}), Ms = We({
  latestVersion: 9,
  versionMap: {
    1: ry,
    2: sy,
    3: oy,
    4: uy,
    5: ly,
    6: dy,
    7: fy,
    8: hy,
    9: yy
  },
  getVersion(e) {
    const t = my.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), vy = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function gy() {
  return {
    v: pl,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: vy,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function _y(e) {
  const t = Ms.safeParse(e);
  return t.type === "ok" ? t.value : gy();
}
function ig(e) {
  return {
    v: pl,
    ...e
  };
}
const by = f({
  v: d(1),
  id: ie(c()),
  // For Firestore ID data
  name: c(),
  requests: b(
    se(
      () => L([
        lt(Tr),
        lt(Ms)
      ])
    )
  )
}), Sy = by.extend({
  folders: se(() => b(ce(F, 1)))
}), Pc = _({
  initial: !0,
  schema: Sy
}), yl = f({
  v: d(2),
  id: ie(c()),
  // For Firestore ID data
  name: c(),
  requests: b(
    se(
      () => L([
        lt(Tr),
        lt(Ms)
      ])
    )
  ),
  auth: L([wu, sl]),
  headers: L([_u, b(qs)])
}), Ay = yl.extend({
  folders: se(() => b(ce(F, 2)))
}), Ty = _({
  initial: !1,
  schema: Ay,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: [],
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 2);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
    return e.id && (t.id = e.id), t;
  }
}), ml = yl.extend({
  v: d(3),
  // AWS Signature Authorization type addition
  auth: L([ku, cl]),
  // `description` field addition under `headers`
  headers: L([br, b(ol)])
}), Ey = ml.extend({
  folders: se(() => b(ce(F, 3)))
}), Ry = _({
  initial: !1,
  schema: Ey,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t,
      folders: e.folders.map((n) => {
        const a = F.safeParseUpToVersion(n, 3);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), vl = ml.extend({
  v: d(4),
  auth: L([ws, ll])
}), wy = vl.extend({
  folders: se(() => b(ce(F, 4)))
}), Cy = _({
  initial: !1,
  schema: wy,
  up(e) {
    return {
      ...e,
      v: 4,
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 4);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), gl = vl.extend({
  v: d(5),
  _ref_id: c().optional()
}), Iy = gl.extend({
  folders: se(() => b(ce(F, 5)))
}), xy = _({
  initial: !1,
  schema: Iy,
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: kt("coll"),
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 5);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), _l = gl.extend({
  v: d(6),
  auth: L([Cs, Rr])
}), Oy = _l.extend({
  folders: se(() => b(ce(F, 6)))
}), ky = _({
  initial: !1,
  schema: Oy,
  up(e) {
    const t = e.auth, r = t.authType === "oauth-2" ? {
      ...t,
      grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...t.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : t.grantTypeInfo
    } : t;
    return {
      ...e,
      auth: r,
      v: 6,
      folders: e.folders.map((a) => {
        const s = F.safeParseUpToVersion(a, 6);
        if (s.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return s.value;
      })
    };
  }
}), bl = _l.extend({
  v: d(7),
  auth: L([ks, Rr])
}), Py = bl.extend({
  folders: se(() => b(ce(F, 7)))
}), qy = _({
  initial: !1,
  schema: Py,
  up(e) {
    return {
      ...e,
      v: 7,
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 7);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Sl = bl.extend({
  v: d(8),
  auth: L([Ps, Rr])
}), Vy = Sl.extend({
  folders: se(() => b(ce(F, 8)))
}), My = _({
  initial: !1,
  schema: Vy,
  up(e) {
    return {
      ...e,
      v: 8,
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 8);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Al = Sl.extend({
  v: d(9),
  auth: L([Ar, hl])
}), Ny = Al.extend({
  folders: se(() => b(ce(F, 9)))
}), $y = _({
  initial: !1,
  schema: Ny,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const n = e.auth.grantTypeInfo;
      let a;
      n.grantType === "AUTHORIZATION_CODE" ? a = {
        ...n,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "CLIENT_CREDENTIALS" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "PASSWORD" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "IMPLICIT" ? a = {
        ...n,
        authRequestParams: [],
        refreshRequestParams: []
      } : a = n, t = {
        ...e.auth,
        grantTypeInfo: a
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t,
      folders: e.folders.map((n) => {
        const a = F.safeParseUpToVersion(n, 9);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), Dy = f({
  key: c(),
  initialValue: c(),
  currentValue: c(),
  secret: E()
}), Tl = Al.extend({
  v: d(10),
  variables: b(Dy)
}), jy = Tl.extend({
  folders: se(() => b(ce(F, 10)))
}), Hy = _({
  initial: !1,
  schema: jy,
  up(e) {
    return {
      ...e,
      v: 10,
      variables: [],
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 10);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Ly = Tl.extend({
  v: d(11),
  description: c().nullable().catch(null)
}), Uy = Ly.extend({
  folders: se(() => b(ce(F, 11)))
}), Ky = _({
  initial: !1,
  schema: Uy,
  up(e) {
    return {
      ...e,
      v: 11,
      description: e.description ?? null,
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 11);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), By = f({
  v: Ze()
}), F = We({
  latestVersion: 11,
  versionMap: {
    1: Pc,
    2: Ty,
    3: Ry,
    4: Cy,
    5: xy,
    6: ky,
    7: qy,
    8: My,
    9: $y,
    10: Hy,
    11: Ky
  },
  getVersion(e) {
    const t = By.safeParse(e);
    return t.success ? t.data.v : Pc.schema.safeParse(e).success ? 1 : null;
  }
}), Gy = 11;
function El(e) {
  return {
    v: Gy,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : kt("coll")
  };
}
function Fy(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(Fy), n = (e.requests ?? []).map(ey), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = e.variables ?? [], o = e.description ?? null, u = El({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i,
    description: o
  });
  return e.id && (u.id = e.id), e._ref_id && (u._ref_id = e._ref_id), u;
}
function Zy(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(Zy), n = (e.requests ?? []).map(_y), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = e.variables ?? [], o = e.description ?? null, u = El({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i,
    description: o
  });
  return e.id && (u.id = e.id), e._ref_id && (u._ref_id = e._ref_id), u;
}
var Me = function(e) {
  return function(t) {
    return !e(t);
  };
}, Wy = Gd, Jy = Kd;
function Rl(e, t) {
  return t === void 0 ? function(r) {
    return Rl(e, r);
  } : Jy(e, t) ? Kc : Bc(t[e]);
}
var wl = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, zy = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var a = e(n, t[n]);
      Uc(a) && r.push(a.value);
    }
    return r;
  };
}, Qy = function(e) {
  return zy(function(t, r) {
    return e(r);
  });
}, Cl = function(e) {
  return e.slice();
}, Yy = Ud, qc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Xy = function(e) {
  return function(t) {
    return qc(qc([], t, !0), [e], !1);
  };
}, em = Xy, tm = function(e) {
  return [e];
}, rm = em, nm = Rl, am = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, sm = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, im = function() {
  return {
    concat: sm().concat,
    empty: []
  };
}, wr = Kc, Pt = Bc;
function Il(e) {
  return function(t) {
    return e(t) ? Pt(t) : wr;
  };
}
var rs = function(e) {
  return function(t) {
    return xl(t) ? wr : Pt(e(t.value));
  };
}, om = Uc, xl = function(e) {
  return e._tag === "None";
}, cm = function(e, t) {
  return function(r) {
    return xl(r) ? e() : t(r.value);
  };
}, um = cm, Ns = um, lm = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, Ne = qd, fe = Vd, dm = /* @__PURE__ */ Id(2, function(e, t) {
  return dt(e) ? e : t(e.right);
}), qt = function(e) {
  return function(t) {
    return dt(t) ? t : fe(e(t.right));
  };
}, Cr = function(e) {
  return function(t) {
    return dt(t) ? Ne(e(t.left)) : t;
  };
}, dt = kd, fm = Pd, hm = function(e) {
  return function(t) {
    return dt(t) ? e(t.left) : t.right;
  };
}, $s = hm, Vc = dm, rr = function() {
  return rr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, rr.apply(this, arguments);
}, Vt = function(e, t, r) {
  return fe({
    value: e,
    next: t,
    start: r
  });
}, Mt = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), Ne({
    input: e,
    expected: t,
    fatal: r
  });
}, pm = function(e, t) {
  return rr(rr({}, e), { expected: t });
}, ym = function(e, t) {
  return mm().concat(e, t);
}, mm = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? Hd().concat(e, t) : e.input.cursor > t.input.cursor ? kr().concat(e, t) : jd({
        input: kr(),
        fatal: kr(),
        expected: im()
      }).concat(e, t);
    }
  };
}, vm = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, gm = function(e) {
  return nm(e.cursor, e.buffer);
}, _m = function(e) {
  return e.cursor >= e.buffer.length;
}, bm = function(e) {
  return S(gm(e), rs(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, xe = function() {
  return xe = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, xe.apply(this, arguments);
}, Ds = function(e) {
  return function(t) {
    return Vt(e, t, t);
  };
}, Sm = function() {
  return function(e) {
    return Mt(e);
  };
}, Am = function(e) {
  return function() {
    return Mt(e);
  };
}, Q = function(e) {
  return S(Rm(Tm()), ze(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? ft(r) : Am(n);
  }));
}, z = function(e, t) {
  return function(r) {
    return S(e(r), Cr(function(n) {
      return pm(n, [t]);
    }));
  };
}, Tm = function() {
  return function(e) {
    return S(bm(e), Ns(function() {
      return Mt(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return Vt(r, n, e);
    }));
  };
}, Em = function(e, t) {
  return function(r) {
    return S(e(r), Vc(function(n) {
      return S(t(n.value)(n.next), Vc(function(a) {
        return Vt(a.value, a.next, r);
      }));
    }));
  };
}, Ir = function(e, t) {
  return function(r) {
    var n = e(r);
    return fm(n) || n.left.fatal ? n : S(t()(r), Cr(function(a) {
      return ym(n.left, a);
    }));
  };
}, Rm = function(e) {
  return function(t) {
    return S(e(t), qt(function(r) {
      return xe(xe({}, r), { value: [r.value, t] });
    }));
  };
}, Ol = function(e) {
  return Qe(function() {
    return ft(e.empty);
  });
}, js = function() {
  return z(function(e) {
    return _m(e) ? Vt(void 0, e, e) : Mt(e);
  }, "end of file");
}, wm = function(e) {
  return S(Hs(e), Qe(function() {
    return ft([]);
  }));
}, Hs = function(e) {
  return S(e, ze(function(t) {
    return Us(tm(t), function(r) {
      return S(e, J(function(n) {
        return Ne(rm(n)(r));
      }), Qe(function() {
        return ft(fe(r));
      }));
    });
  }));
}, Cm = function(e, t) {
  return function(r) {
    return S(e, ze(function() {
      return r;
    }), Ks(function() {
      return t;
    }));
  };
}, kl = function(e) {
  return Cm(e, e);
}, Im = function(e) {
  return wm(Q(Me(e)));
}, Ls = function(e, t) {
  return S(t, J(function() {
    return Yy;
  }), Qe(function() {
    return xm(e, t);
  }));
}, xm = function(e, t) {
  return S(e, ze(function(r) {
    return Us(Fd(r), function(n) {
      return S(t, J(function() {
        return fe(n);
      }), Qe(function() {
        return S(e, J(function(a) {
          return Ne(Wy(a)(n));
        }));
      }));
    });
  }));
}, Nt = function(e, t) {
  return function(r) {
    return S(e(r), qt(function(n) {
      return xe(xe({}, n), { value: t(n.value) });
    }));
  };
}, Pl = function(e, t) {
  return xr(e, function(r) {
    return Nt(t, r);
  });
}, xr = function(e, t) {
  return Em(e, t);
}, Us = function(e, t) {
  var r = function(n) {
    return function(a) {
      return dt(a.value) ? Ne({ value: a.value.left, stream: a.next }) : fe(Vt(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return lm({ value: e, stream: n }, function(a) {
      var s = t(a.value)(a.stream);
      return dt(s) ? fe(Mt(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, Om = function(e, t) {
  return Ir(e, t);
}, J = function(e) {
  return function(t) {
    return Nt(t, e);
  };
}, ft = Ds, ze = function(e) {
  return function(t) {
    return xr(t, e);
  };
}, Ks = function(e) {
  return function(t) {
    return xr(t, function(r) {
      return Nt(e(r), function() {
        return r;
      });
    });
  };
}, Qe = function(e) {
  return function(t) {
    return Om(t, e);
  };
}, km = "Parser", Pm = function(e) {
  return {
    concat: function(t, r) {
      return Pl(Nt(t, function(n) {
        return function(a) {
          return e.concat(n, a);
        };
      }), r);
    }
  };
}, qm = function(e) {
  return xe(xe({}, Pm(e)), { empty: Ds(e.empty) });
}, Vm = {
  URI: km,
  map: Nt,
  ap: Pl,
  chain: xr,
  chainRec: Us
}, ql = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, Vl = function(e) {
  return function(t) {
    return S(t, J(function(r) {
      return ql({}, e, r);
    }));
  };
}, ns = function(e, t) {
  return function(r) {
    return S(r, ze(function(n) {
      return S(t(n), J(function(a) {
        return ql(n, e, a);
      }));
    }));
  };
}, Mm = function(e) {
  return Ld(e)(e.empty);
}, Nm = Ol(os), ht = function(e) {
  return z(Q(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, $m = function(e) {
  return z(Q(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, Bs = function(e) {
  return Nm($t(e));
}, $t = function(e) {
  return S(Hs(e), J(function(t) {
    return t.join("");
  }));
}, Gs = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, as = z(Q(Gs), "a digit"), Dm = /^\s$/, Ml = function(e) {
  return Dm.test(e);
}, Nl = z(Q(Ml), "a whitespace"), jm = function(e) {
  return e === "_";
}, Dt = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, $l = function(e) {
  return Dt(e) || Gs(e) || jm(e);
};
z(Q($l), "a word character");
z(Q(Dt), "a letter");
var Hm = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
z(Q(Hm), "an unicode letter");
var Dl = function(e) {
  return Dt(e) && e === e.toUpperCase();
};
z(Q(Dl), "an upper case letter");
var jl = function(e) {
  return Dt(e) && e === e.toLowerCase();
};
z(Q(jl), "a lower case letter");
z(Q(Me(Gs)), "a non-digit");
var Hl = z(Q(Me(Ml)), "a non-whitespace character");
z(Q(Me($l)), "a non-word character");
z(Q(Me(Dt)), "a non-letter character");
z(Q(Me(Dl)), "anything but an upper case letter");
z(Q(Me(jl)), "anything but a lower case letter");
var Ll = function(e) {
  return z(Vm.chainRec(e, function(t) {
    return S(Km(0, t), Ns(function() {
      return ft(fe(e));
    }, function(r) {
      return S(ht(r), ze(function() {
        return ft(Ne(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, ss = Mm(qm(os)), It = Ol(os), Lm = function(e) {
  return It(Um(e));
}, Um = function(e) {
  return S(Hs(e), J(function(t) {
    return t.join("");
  }));
}, Km = function(e, t) {
  return e >= 0 && e < t.length ? Pt(t.charAt(e)) : wr;
}, Bm = Bs(Nl);
$t(Nl);
Bs(Hl);
$t(Hl);
var Gm = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? wr : Pt(t);
};
z(S(ss([It(ht("-")), $t(as)]), J(function(e) {
  return +e;
})), "an integer");
z(S(ss([It(ht("-")), Bs(as), It(ss([ht("."), $t(as)]))]), ze(function(e) {
  return S(Gm(e), Ns(function() {
    return Sm();
  }, Ds));
})), "a float");
var Fm = kl(ht('"'))(Lm(Ir(Ll('\\"'), function() {
  return $m('"');
})));
function Ul(e) {
  return function(t) {
    return t(vm(e.split("")));
  };
}
const Mc = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), Zm = ["#", ":"], pt = kl(Bm), Fs = (e) => (t) => t.join(e), Zs = (e) => S(
  Im((t) => e.includes(t)),
  J(Fs(""))
), Wm = we(
  Zs,
  Ks(() => Q(() => !0))
), Kl = S(
  Fm,
  J((e) => JSON.parse(`"${e}"`))
), Jm = S(
  pt(Kl),
  Qe(
    () => S(
      Zs([":", `
`]),
      J(Gc)
    )
  )
), zm = S(
  pt(Kl),
  Qe(
    () => S(
      Zs([`
`]),
      J(Gc)
    )
  )
), Bl = S(
  It(Ll("#")),
  J(Me(Fc))
), Gl = S(
  pt(Bl),
  Vl("commented"),
  ns("key", () => pt(Jm)),
  Ks(() => ht(":")),
  ns("value", () => zm)
), Qm = S(
  pt(Bl),
  Vl("commented"),
  ns("key", () => Ir(
    Wm([`
`]),
    () => S(
      Ls(Q((e) => !0), js()),
      J(we(
        Cl,
        Fs("")
      ))
    )
  )),
  J(we(
    Il(({ key: e }) => !Fc(e))
  ))
), Ym = S(
  Ls(pt(Gl), js())
), Xm = S(
  Ls(
    Ir(
      S(Gl, J(Pt)),
      () => S(
        Qm,
        J(we(
          rs((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    js()
  ),
  J(we(
    Qy(we(
      Il(om),
      rs((e) => e.value)
    ))
  ))
), ev = (e) => {
  if (Zm.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, Nc = (e) => ev(e) ? JSON.stringify(e) : e, og = (e) => S(
  e,
  am(
    we(
      Mc("key", Nc),
      Mc("value", Nc),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  Fs(`
`)
), tv = (e) => S(
  Xm,
  Ul(e),
  Cr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  qt(
    ({ value: t }) => S(
      t,
      wl(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), cg = (e) => S(
  Ym,
  Ul(e),
  Cr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  qt(
    ({ value: t }) => S(
      t,
      wl(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), ug = we(
  tv,
  qt(Cl),
  $s(() => [])
), rv = f({
  id: ie(c()),
  name: c(),
  variables: b(
    f({
      key: c(),
      value: c()
    })
  )
}), $c = _({
  initial: !0,
  schema: rv
}), Fl = () => Math.random().toString(36).substring(2, 16), Zl = f({
  v: d(1),
  id: c(),
  name: c(),
  variables: b(
    L([
      f({
        key: c(),
        secret: d(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: d(!1).catch(!1)
      })
    ])
  )
}), nv = _({
  initial: !1,
  schema: Zl,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || Fl(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), av = Zl.extend({
  v: d(2),
  variables: b(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: E()
    })
  )
}), sv = _({
  initial: !1,
  schema: av,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a,
          initialValue: a ? "" : r.value,
          currentValue: a ? "" : r.value
        };
      })
    };
  }
}), Wl = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Company names
  {
    key: "$randomCompanyName",
    description: "A random company name.",
    getValue: () => {
      const e = [
        "Nexora",
        "CodeLoom",
        "BitHaven",
        "SynapseWorks",
        "VoltEdge",
        "Elevoria",
        "Bridgent",
        "Verniq",
        "Corevia",
        "Stratigen",
        "Lunova Studio",
        "Pixelora",
        "MuseMind",
        "BrightNest",
        "Auralis",
        "VerdaFlow",
        "BloomShift",
        "PureTrek",
        "EcoVerse",
        "ReLeaf Labs"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], iv = f({
  v: Ze()
}), lg = We({
  latestVersion: 2,
  versionMap: {
    0: $c,
    1: nv,
    2: sv
  },
  getVersion(e) {
    const t = iv.safeParse(e);
    return t.success ? t.data.v : $c.schema.safeParse(e).success ? 0 : null;
  }
}), nr = /<<([^>]*)>>/g, ar = 10, Jl = "ENV_EXPAND_LOOP", Dc = 2;
function ov(e, t) {
  let r = e, n = 0;
  for (; r.match(nr) != null && n <= ar; )
    r = r.replace(nr, (a) => {
      const s = a.replace(/[<>]/g, ""), i = Wl.find(
        (u) => u.key === s
      );
      if (i)
        return i.getValue();
      const o = t.find((u) => u.key === s);
      return o && "currentValue" in o ? o.currentValue : a;
    }), n++;
  return n > ar ? Ne(Jl) : fe(r);
}
const dg = (e, t) => S(
  ov(e, t),
  $s(() => e)
);
function cv(e, t, r = !1, n = !1) {
  if (!t || !e)
    return fe(e);
  let a = e, s = 0, i = !1;
  for (; a.match(nr) != null && s <= ar && !i; )
    a = decodeURI(encodeURI(a)).replace(nr, (o, u) => {
      const l = Wl.find(
        (m) => m.key === u
      );
      if (l)
        return l.getValue();
      const h = t.find((m) => m && m.key === u);
      return h && "currentValue" in h ? h.secret && n ? (i = !0, `<<${u}>>`) : h.secret && r ? "*".repeat(
        h.currentValue.length
      ) : h.currentValue : "";
    }), s++;
  return s > ar ? Ne(Jl) : fe(a);
}
const fg = (e, t, r = !1, n = !1) => S(
  cv(e, t, r, n),
  $s(() => e)
), uv = (e) => ({
  key: e.key,
  initialValue: e.initialValue ?? e.value ?? "",
  currentValue: e.currentValue ?? e.value ?? "",
  secret: e.secret ?? !1
}), hg = (e) => {
  if (e.v && e.v === Dc) return e;
  const t = e.id || Fl(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(uv);
  return {
    v: Dc,
    id: t,
    name: r,
    variables: n
  };
}, lv = b(
  L([
    f({
      key: c(),
      value: c(),
      secret: d(!1)
    }),
    f({
      key: c(),
      secret: d(!0)
    }),
    f({
      key: c(),
      value: c()
    })
  ])
), jc = _({
  initial: !0,
  schema: lv
}), zl = f({
  v: d(1),
  variables: b(
    L([
      f({
        key: c(),
        secret: d(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: d(!1)
      })
    ])
  )
}), dv = _({
  initial: !1,
  schema: zl,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), fv = zl.extend({
  v: d(2),
  variables: b(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: E()
    })
  )
}), hv = _({
  initial: !1,
  schema: fv,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a ?? !1,
          initialValue: r.secret ? "" : r.value,
          currentValue: r.secret ? "" : r.value
        };
      })
    };
  }
}), pv = f({
  v: Ze()
}), pg = We({
  latestVersion: 2,
  versionMap: {
    0: jc,
    1: dv,
    2: hv
  },
  getVersion(e) {
    const t = pv.safeParse(e);
    return t.success ? t.data.v : jc.schema.safeParse(e).success ? 0 : null;
  }
});
async function yv(e = 6) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, e);
}
function mv(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-256", r);
}
function vv(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-1", r);
}
async function gv(e, t) {
  return t === "sha256" ? mv(e) : vv(e);
}
async function _v(e, t, r) {
  const n = new TextEncoder(), a = n.encode(e), s = n.encode(t), i = r === "sha256" ? "SHA-256" : "SHA-1", o = await crypto.subtle.importKey(
    "raw",
    a,
    {
      name: "HMAC",
      hash: { name: i }
    },
    !1,
    ["sign"]
  ), u = await crypto.subtle.sign("HMAC", o, s);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(u)]));
}
function nt(e) {
  return e.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
}
async function bv(e, t) {
  if (!e) return "";
  if (e instanceof FormData)
    if (t === "multipart/form-data") {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" ? r.push(`${a}=${n}`) : r.push(`${a}=${n instanceof File ? n.name : "blob"}`);
      }), nt(r.join("&"));
    } else {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" && r.push(`${a}=${encodeURIComponent(n)}`);
      }), nt(r.join("&"));
    }
  if (e instanceof Blob)
    try {
      const r = await e.text();
      return nt(r);
    } catch (r) {
      return console.error("Failed to read blob content", r), "";
    }
  if (t.includes("application/json") && typeof e == "string")
    try {
      const r = JSON.parse(e);
      return nt(JSON.stringify(r));
    } catch {
      return nt(e.toString());
    }
  return nt(e.toString());
}
async function yg(e) {
  const t = e.timestamp !== void 0 && e.timestamp !== null ? e.timestamp : Math.floor(Date.now() / 1e3), r = e.nonce && e.nonce !== "" ? e.nonce : await yv(), n = new URL(e.url), a = n.hostname, s = n.port || (n.protocol === "https:" ? "443" : "80"), i = n.pathname + n.search, o = {
    ts: t,
    nonce: r,
    method: e.method.toUpperCase(),
    resource: i,
    host: a,
    port: s,
    hash: "",
    ext: e.ext || ""
  };
  if (e.includePayloadHash && e.payload)
    try {
      const m = e.contentType || "text/plain", R = await bv(e.payload, m), N = `hawk.1.payload
${m}
${R}
`, U = await gv(N, e.algorithm);
      o.hash = btoa(
        String.fromCharCode.apply(null, [...new Uint8Array(U)])
      );
    } catch (m) {
      console.error("Error calculating payload hash:", m);
    }
  const u = `hawk.1.header
${o.ts}
${o.nonce}
${o.method}
${o.resource}
${o.host}
${o.port}
${o.hash}
${o.ext}
`, l = await _v(e.key, u, e.algorithm), h = [
    `Hawk id="${e.id}"`,
    `ts="${o.ts}"`,
    `nonce="${o.nonce}"`,
    `mac="${l}"`
  ];
  return e.ext && e.ext !== "" && h.push(`ext="${e.ext}"`), e.app && e.app !== "" && h.push(`app="${e.app}"`), e.dlg && e.dlg !== "" && h.push(`dlg="${e.dlg}"`), o.hash !== "" && h.push(`hash="${o.hash}"`), h.join(", ");
}
async function mg(e) {
  const t = new TextEncoder();
  new TextDecoder();
  const r = e.timestamp || Math.floor(Date.now() / 1e3).toString(), n = e.nonce || crypto.randomUUID(), a = e.host || new URL(e.url).host, s = await crypto.subtle.importKey(
    "raw",
    t.encode(e.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(r)
  );
  let i = "";
  if (e.body) {
    const m = await crypto.subtle.digest(
      "SHA-256",
      t.encode(e.body)
    );
    i = Array.from(new Uint8Array(m)).map((R) => R.toString(16).padStart(2, "0")).join("");
  }
  const o = `${e.method} ${e.url} ${a} ${r} ${n} ${i}`, u = await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(o)
  ), l = btoa(
    String.fromCharCode(...new Uint8Array(u))
  );
  return `EG1-HMAC-SHA256 client_token=${e.clientToken};access_token=${e.accessToken};timestamp=${r};nonce=${n};signature=${l}`;
}
const Ql = new TextEncoder(), Hc = new TextDecoder();
function Sv(...e) {
  const t = e.reduce((a, { length: s }) => a + s, 0), r = new Uint8Array(t);
  let n = 0;
  for (const a of e)
    r.set(a, n), n += a.length;
  return r;
}
function Fa(e) {
  const t = new Uint8Array(e.length);
  for (let r = 0; r < e.length; r++) {
    const n = e.charCodeAt(r);
    if (n > 127)
      throw new TypeError("non-ASCII string encountered in encode()");
    t[r] = n;
  }
  return t;
}
function Av(e) {
  if (Uint8Array.prototype.toBase64)
    return e.toBase64();
  const t = 32768, r = [];
  for (let n = 0; n < e.length; n += t)
    r.push(String.fromCharCode.apply(null, e.subarray(n, n + t)));
  return btoa(r.join(""));
}
function Tv(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function Ev(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(typeof e == "string" ? e : Hc.decode(e), {
      alphabet: "base64url"
    });
  let t = e;
  t instanceof Uint8Array && (t = Hc.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return Tv(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
function Za(e) {
  let t = e;
  return typeof t == "string" && (t = Ql.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({ alphabet: "base64url", omitPadding: !0 }) : Av(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
class Ws extends Error {
  static code = "ERR_JOSE_GENERIC";
  code = "ERR_JOSE_GENERIC";
  constructor(t, r) {
    super(t, r), this.name = this.constructor.name, Error.captureStackTrace?.(this, this.constructor);
  }
}
class Le extends Ws {
  static code = "ERR_JOSE_NOT_SUPPORTED";
  code = "ERR_JOSE_NOT_SUPPORTED";
}
class gt extends Ws {
  static code = "ERR_JWS_INVALID";
  code = "ERR_JWS_INVALID";
}
class Rv extends Ws {
  static code = "ERR_JWT_INVALID";
  code = "ERR_JWT_INVALID";
}
const ue = (e, t = "algorithm.name") => new TypeError(`CryptoKey does not support this operation, its ${t} must be ${e}`), at = (e, t) => e.name === t;
function Wa(e) {
  return parseInt(e.name.slice(4), 10);
}
function wv(e) {
  switch (e) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function Cv(e, t) {
  if (!e.usages.includes(t))
    throw new TypeError(`CryptoKey does not support this operation, its usages must include ${t}.`);
}
function Iv(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!at(e.algorithm, "HMAC"))
        throw ue("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (Wa(e.algorithm.hash) !== n)
        throw ue(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!at(e.algorithm, "RSASSA-PKCS1-v1_5"))
        throw ue("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (Wa(e.algorithm.hash) !== n)
        throw ue(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!at(e.algorithm, "RSA-PSS"))
        throw ue("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (Wa(e.algorithm.hash) !== n)
        throw ue(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "Ed25519":
    case "EdDSA": {
      if (!at(e.algorithm, "Ed25519"))
        throw ue("Ed25519");
      break;
    }
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87": {
      if (!at(e.algorithm, t))
        throw ue(t);
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!at(e.algorithm, "ECDSA"))
        throw ue("ECDSA");
      const n = wv(t);
      if (e.algorithm.namedCurve !== n)
        throw ue(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  Cv(e, r);
}
function Yl(e, t, ...r) {
  if (r = r.filter(Boolean), r.length > 2) {
    const n = r.pop();
    e += `one of type ${r.join(", ")}, or ${n}.`;
  } else r.length === 2 ? e += `one of type ${r[0]} or ${r[1]}.` : e += `of type ${r[0]}.`;
  return t == null ? e += ` Received ${t}` : typeof t == "function" && t.name ? e += ` Received function ${t.name}` : typeof t == "object" && t != null && t.constructor?.name && (e += ` Received an instance of ${t.constructor.name}`), e;
}
const xv = (e, ...t) => Yl("Key must be ", e, ...t), Xl = (e, t, ...r) => Yl(`Key for the ${e} algorithm must be `, t, ...r), ed = (e) => {
  if (e?.[Symbol.toStringTag] === "CryptoKey")
    return !0;
  try {
    return e instanceof CryptoKey;
  } catch {
    return !1;
  }
}, td = (e) => e?.[Symbol.toStringTag] === "KeyObject", rd = (e) => ed(e) || td(e);
function Ov(...e) {
  const t = e.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let r;
  for (const n of t) {
    const a = Object.keys(n);
    if (!r || r.size === 0) {
      r = new Set(a);
      continue;
    }
    for (const s of a) {
      if (r.has(s))
        return !1;
      r.add(s);
    }
  }
  return !0;
}
const kv = (e) => typeof e == "object" && e !== null;
function nd(e) {
  if (!kv(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Pv(e, t) {
  if (e.startsWith("RS") || e.startsWith("PS")) {
    const { modulusLength: r } = t.algorithm;
    if (typeof r != "number" || r < 2048)
      throw new TypeError(`${e} requires key modulusLength to be 2048 bits or larger`);
  }
}
function qv(e) {
  let t, r;
  switch (e.kty) {
    case "AKP": {
      switch (e.alg) {
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
          t = { name: e.alg }, r = e.priv ? ["sign"] : ["verify"];
          break;
        default:
          throw new Le('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "RSA": {
      switch (e.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(e.alg.slice(-3), 10) || 1}`
          }, r = e.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new Le('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (e.alg) {
        case "ES256":
          t = { name: "ECDSA", namedCurve: "P-256" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          t = { name: "ECDSA", namedCurve: "P-384" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          t = { name: "ECDSA", namedCurve: "P-521" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Le('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (e.alg) {
        case "Ed25519":
        case "EdDSA":
          t = { name: "Ed25519" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Le('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new Le('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: r };
}
async function Vv(e) {
  if (!e.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: t, keyUsages: r } = qv(e), n = { ...e };
  return n.kty !== "AKP" && delete n.alg, delete n.use, crypto.subtle.importKey("jwk", n, t, e.ext ?? !(e.d || e.priv), e.key_ops ?? r);
}
function Mv(e, t, r, n, a) {
  if (a.crit !== void 0 && n?.crit === void 0)
    throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let s;
  r !== void 0 ? s = new Map([...Object.entries(r), ...t.entries()]) : s = t;
  for (const i of n.crit) {
    if (!s.has(i))
      throw new Le(`Extension Header Parameter "${i}" is not recognized`);
    if (a[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" is missing`);
    if (s.get(i) && n[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return new Set(n.crit);
}
const Js = (e) => nd(e) && typeof e.kty == "string", Nv = (e) => e.kty !== "oct" && (e.kty === "AKP" && typeof e.priv == "string" || typeof e.d == "string"), $v = (e) => e.kty !== "oct" && e.d === void 0 && e.priv === void 0, Dv = (e) => e.kty === "oct" && typeof e.k == "string";
let ot;
const Lc = async (e, t, r, n = !1) => {
  ot ||= /* @__PURE__ */ new WeakMap();
  let a = ot.get(e);
  if (a?.[r])
    return a[r];
  const s = await Vv({ ...t, alg: r });
  return n && Object.freeze(e), a ? a[r] = s : ot.set(e, { [r]: s }), s;
}, jv = (e, t) => {
  ot ||= /* @__PURE__ */ new WeakMap();
  let r = ot.get(e);
  if (r?.[t])
    return r[t];
  const n = e.type === "public", a = !!n;
  let s;
  if (e.asymmetricKeyType === "x25519") {
    switch (t) {
      case "ECDH-ES":
      case "ECDH-ES+A128KW":
      case "ECDH-ES+A192KW":
      case "ECDH-ES+A256KW":
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    s = e.toCryptoKey(e.asymmetricKeyType, a, n ? [] : ["deriveBits"]);
  }
  if (e.asymmetricKeyType === "ed25519") {
    if (t !== "EdDSA" && t !== "Ed25519")
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    s = e.toCryptoKey(e.asymmetricKeyType, a, [
      n ? "verify" : "sign"
    ]);
  }
  switch (e.asymmetricKeyType) {
    case "ml-dsa-44":
    case "ml-dsa-65":
    case "ml-dsa-87": {
      if (t !== e.asymmetricKeyType.toUpperCase())
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
      s = e.toCryptoKey(e.asymmetricKeyType, a, [
        n ? "verify" : "sign"
      ]);
    }
  }
  if (e.asymmetricKeyType === "rsa") {
    let i;
    switch (t) {
      case "RSA-OAEP":
        i = "SHA-1";
        break;
      case "RS256":
      case "PS256":
      case "RSA-OAEP-256":
        i = "SHA-256";
        break;
      case "RS384":
      case "PS384":
      case "RSA-OAEP-384":
        i = "SHA-384";
        break;
      case "RS512":
      case "PS512":
      case "RSA-OAEP-512":
        i = "SHA-512";
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    if (t.startsWith("RSA-OAEP"))
      return e.toCryptoKey({
        name: "RSA-OAEP",
        hash: i
      }, a, n ? ["encrypt"] : ["decrypt"]);
    s = e.toCryptoKey({
      name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
      hash: i
    }, a, [n ? "verify" : "sign"]);
  }
  if (e.asymmetricKeyType === "ec") {
    const o = (/* @__PURE__ */ new Map([
      ["prime256v1", "P-256"],
      ["secp384r1", "P-384"],
      ["secp521r1", "P-521"]
    ])).get(e.asymmetricKeyDetails?.namedCurve);
    if (!o)
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    t === "ES256" && o === "P-256" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: o
    }, a, [n ? "verify" : "sign"])), t === "ES384" && o === "P-384" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: o
    }, a, [n ? "verify" : "sign"])), t === "ES512" && o === "P-521" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: o
    }, a, [n ? "verify" : "sign"])), t.startsWith("ECDH-ES") && (s = e.toCryptoKey({
      name: "ECDH",
      namedCurve: o
    }, a, n ? [] : ["deriveBits"]));
  }
  if (!s)
    throw new TypeError("given KeyObject instance cannot be used for this algorithm");
  return r ? r[t] = s : ot.set(e, { [t]: s }), s;
};
async function Hv(e, t) {
  if (e instanceof Uint8Array || ed(e))
    return e;
  if (td(e)) {
    if (e.type === "secret")
      return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function")
      try {
        return jv(e, t);
      } catch (n) {
        if (n instanceof TypeError)
          throw n;
      }
    let r = e.export({ format: "jwk" });
    return Lc(e, r, t);
  }
  if (Js(e))
    return e.k ? Ev(e.k) : Lc(e, e, t, !0);
  throw new Error("unreachable");
}
const it = (e) => e?.[Symbol.toStringTag], is = (e, t, r) => {
  if (t.use !== void 0) {
    let n;
    switch (r) {
      case "sign":
      case "verify":
        n = "sig";
        break;
      case "encrypt":
      case "decrypt":
        n = "enc";
        break;
    }
    if (t.use !== n)
      throw new TypeError(`Invalid key for this operation, its "use" must be "${n}" when present`);
  }
  if (t.alg !== void 0 && t.alg !== e)
    throw new TypeError(`Invalid key for this operation, its "alg" must be "${e}" when present`);
  if (Array.isArray(t.key_ops)) {
    let n;
    switch (!0) {
      case r === "sign":
      case e === "dir":
      case e.includes("CBC-HS"):
        n = r;
        break;
      case e.startsWith("PBES2"):
        n = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        !e.includes("GCM") && e.endsWith("KW") ? n = "unwrapKey" : n = r;
        break;
      case r === "encrypt":
        n = "wrapKey";
        break;
      case r === "decrypt":
        n = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        break;
    }
    if (n && t.key_ops?.includes?.(n) === !1)
      throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${n}" when present`);
  }
  return !0;
}, Lv = (e, t, r) => {
  if (!(t instanceof Uint8Array)) {
    if (Js(t)) {
      if (Dv(t) && is(e, t, r))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!rd(t))
      throw new TypeError(Xl(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
    if (t.type !== "secret")
      throw new TypeError(`${it(t)} instances for symmetric algorithms must be of type "secret"`);
  }
}, Uv = (e, t, r) => {
  if (Js(t))
    switch (r) {
      case "decrypt":
      case "sign":
        if (Nv(t) && is(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation must be a private JWK");
      case "encrypt":
      case "verify":
        if ($v(t) && is(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation must be a public JWK");
    }
  if (!rd(t))
    throw new TypeError(Xl(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
  if (t.type === "secret")
    throw new TypeError(`${it(t)} instances for asymmetric algorithms must not be of type "secret"`);
  if (t.type === "public")
    switch (r) {
      case "sign":
        throw new TypeError(`${it(t)} instances for asymmetric algorithm signing must be of type "private"`);
      case "decrypt":
        throw new TypeError(`${it(t)} instances for asymmetric algorithm decryption must be of type "private"`);
    }
  if (t.type === "private")
    switch (r) {
      case "verify":
        throw new TypeError(`${it(t)} instances for asymmetric algorithm verifying must be of type "public"`);
      case "encrypt":
        throw new TypeError(`${it(t)} instances for asymmetric algorithm encryption must be of type "public"`);
    }
};
function Kv(e, t, r) {
  switch (e.substring(0, 2)) {
    case "A1":
    case "A2":
    case "di":
    case "HS":
    case "PB":
      Lv(e, t, r);
      break;
    default:
      Uv(e, t, r);
  }
}
function Bv(e, t) {
  const r = `SHA-${e.slice(-3)}`;
  switch (e) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: r, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: r, name: "RSA-PSS", saltLength: parseInt(e.slice(-3), 10) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: r, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: r, name: "ECDSA", namedCurve: t.namedCurve };
    case "Ed25519":
    case "EdDSA":
      return { name: "Ed25519" };
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      return { name: e };
    default:
      throw new Le(`alg ${e} is not supported either by JOSE or your javascript runtime`);
  }
}
async function Gv(e, t, r) {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS"))
      throw new TypeError(xv(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: `SHA-${e.slice(-3)}`, name: "HMAC" }, !1, [r]);
  }
  return Iv(t, e, r), t;
}
const je = (e) => Math.floor(e.getTime() / 1e3), ad = 60, sd = ad * 60, zs = sd * 24, Fv = zs * 7, Zv = zs * 365.25, Wv = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function Ja(e) {
  const t = Wv.exec(e);
  if (!t || t[4] && t[1])
    throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]), n = t[3].toLowerCase();
  let a;
  switch (n) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      a = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      a = Math.round(r * ad);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      a = Math.round(r * sd);
      break;
    case "day":
    case "days":
    case "d":
      a = Math.round(r * zs);
      break;
    case "week":
    case "weeks":
    case "w":
      a = Math.round(r * Fv);
      break;
    default:
      a = Math.round(r * Zv);
      break;
  }
  return t[1] === "-" || t[4] === "ago" ? -a : a;
}
function He(e, t) {
  if (!Number.isFinite(t))
    throw new TypeError(`Invalid ${e} input`);
  return t;
}
class Jv {
  #e;
  constructor(t) {
    if (!nd(t))
      throw new TypeError("JWT Claims Set MUST be an object");
    this.#e = structuredClone(t);
  }
  data() {
    return Ql.encode(JSON.stringify(this.#e));
  }
  get iss() {
    return this.#e.iss;
  }
  set iss(t) {
    this.#e.iss = t;
  }
  get sub() {
    return this.#e.sub;
  }
  set sub(t) {
    this.#e.sub = t;
  }
  get aud() {
    return this.#e.aud;
  }
  set aud(t) {
    this.#e.aud = t;
  }
  set jti(t) {
    this.#e.jti = t;
  }
  set nbf(t) {
    typeof t == "number" ? this.#e.nbf = He("setNotBefore", t) : t instanceof Date ? this.#e.nbf = He("setNotBefore", je(t)) : this.#e.nbf = je(/* @__PURE__ */ new Date()) + Ja(t);
  }
  set exp(t) {
    typeof t == "number" ? this.#e.exp = He("setExpirationTime", t) : t instanceof Date ? this.#e.exp = He("setExpirationTime", je(t)) : this.#e.exp = je(/* @__PURE__ */ new Date()) + Ja(t);
  }
  set iat(t) {
    t === void 0 ? this.#e.iat = je(/* @__PURE__ */ new Date()) : t instanceof Date ? this.#e.iat = He("setIssuedAt", je(t)) : typeof t == "string" ? this.#e.iat = He("setIssuedAt", je(/* @__PURE__ */ new Date()) + Ja(t)) : this.#e.iat = He("setIssuedAt", t);
  }
}
async function zv(e, t, r) {
  const n = await Gv(e, t, "sign");
  Pv(e, n);
  const a = await crypto.subtle.sign(Bv(e, n.algorithm), n, r);
  return new Uint8Array(a);
}
class Qv {
  #e;
  #t;
  #r;
  constructor(t) {
    if (!(t instanceof Uint8Array))
      throw new TypeError("payload must be an instance of Uint8Array");
    this.#e = t;
  }
  setProtectedHeader(t) {
    if (this.#t)
      throw new TypeError("setProtectedHeader can only be called once");
    return this.#t = t, this;
  }
  setUnprotectedHeader(t) {
    if (this.#r)
      throw new TypeError("setUnprotectedHeader can only be called once");
    return this.#r = t, this;
  }
  async sign(t, r) {
    if (!this.#t && !this.#r)
      throw new gt("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    if (!Ov(this.#t, this.#r))
      throw new gt("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const n = {
      ...this.#t,
      ...this.#r
    }, a = Mv(gt, /* @__PURE__ */ new Map([["b64", !0]]), r?.crit, this.#t, n);
    let s = !0;
    if (a.has("b64") && (s = this.#t.b64, typeof s != "boolean"))
      throw new gt('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: i } = n;
    if (typeof i != "string" || !i)
      throw new gt('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    Kv(i, t, "sign");
    let o, u;
    s ? (o = Za(this.#e), u = Fa(o)) : (u = this.#e, o = "");
    let l, h;
    this.#t ? (l = Za(JSON.stringify(this.#t)), h = Fa(l)) : (l = "", h = new Uint8Array());
    const m = Sv(h, Fa("."), u), R = await Hv(t, i), N = await zv(i, R, m), U = {
      signature: Za(N),
      payload: o
    };
    return this.#r && (U.header = this.#r), this.#t && (U.protected = l), U;
  }
}
class Yv {
  #e;
  constructor(t) {
    this.#e = new Qv(t);
  }
  setProtectedHeader(t) {
    return this.#e.setProtectedHeader(t), this;
  }
  async sign(t, r) {
    const n = await this.#e.sign(t, r);
    if (n.payload === void 0)
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    return `${n.protected}.${n.payload}.${n.signature}`;
  }
}
class Xv {
  #e;
  #t;
  constructor(t = {}) {
    this.#t = new Jv(t);
  }
  setIssuer(t) {
    return this.#t.iss = t, this;
  }
  setSubject(t) {
    return this.#t.sub = t, this;
  }
  setAudience(t) {
    return this.#t.aud = t, this;
  }
  setJti(t) {
    return this.#t.jti = t, this;
  }
  setNotBefore(t) {
    return this.#t.nbf = t, this;
  }
  setExpirationTime(t) {
    return this.#t.exp = t, this;
  }
  setIssuedAt(t) {
    return this.#t.iat = t, this;
  }
  setProtectedHeader(t) {
    return this.#e = t, this;
  }
  async sign(t, r) {
    const n = new Yv(this.#t.data());
    if (n.setProtectedHeader(this.#e), Array.isArray(this.#e?.crit) && this.#e.crit.includes("b64") && this.#e.b64 === !1)
      throw new Rv("JWTs MUST NOT use unencoded payload");
    return n.sign(t, r);
  }
}
async function vg(e) {
  const {
    algorithm: t,
    secret: r,
    privateKey: n,
    payload: a,
    jwtHeaders: s,
    isSecretBase64Encoded: i
  } = e;
  let o = {}, u = {};
  try {
    const l = a?.trim() || "{}";
    l === "" ? o = {} : o = JSON.parse(l);
  } catch (l) {
    return console.error("Failed to parse JWT payload JSON:", l), console.error("Payload value:", a), null;
  }
  try {
    const l = s?.trim() || "{}";
    l === "" ? u = {} : u = JSON.parse(l);
  } catch (l) {
    return console.error("Failed to parse JWT headers JSON:", l), console.error("Headers value:", s), null;
  }
  try {
    let l;
    if (t.startsWith("RS") || t.startsWith("ES") || t.startsWith("PS")) {
      if (!n)
        return console.error("Private key is required for RSA/ECDSA algorithms"), null;
      l = new TextEncoder().encode(n);
    } else {
      if (!r)
        return console.error("Secret is required for HMAC algorithms"), null;
      l = i ? Uint8Array.from(Buffer.from(r, "base64")) : new TextEncoder().encode(r);
    }
    return await new Xv(o).setProtectedHeader({
      alg: t,
      ...u
    }).sign(l);
  } catch (l) {
    return console.error("Error generating JWT token:", l), null;
  }
}
const gg = f({
  name: c(),
  // Cookie name
  value: c(),
  // Cookie value
  domain: c(),
  // Domain the cookie belongs to
  path: c(),
  // Path scope of the cookie (default: "/")
  expires: c().optional(),
  // Expiration date in ISO format, null for session cookies
  maxAge: Ze().optional(),
  // Maximum age in seconds, null if not set
  httpOnly: E(),
  // Whether cookie is HTTP-only (not accessible via JavaScript)
  secure: E(),
  // Whether cookie should only be sent over HTTPS
  sameSite: ee(["None", "Lax", "Strict"])
  // SameSite attribute for CSRF protection
});
export {
  gp as AuthCodeGrantTypeParams,
  _p as ClientCredentialsGrantTypeParams,
  Gy as CollectionSchemaVersion,
  Dy as CollectionVariable,
  gg as CookieSchema,
  lg as Environment,
  Dc as EnvironmentSchemaVersion,
  Mu as FormDataKeyValue,
  ol as GQLHeader,
  pl as GQL_REQ_SCHEMA_VERSION,
  pg as GlobalEnvironment,
  Wl as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  F as HoppCollection,
  hl as HoppGQLAuth,
  vt as HoppGQLAuthAPIKey,
  Er as HoppGQLAuthAWSSignature,
  Pe as HoppGQLAuthBasic,
  qe as HoppGQLAuthBearer,
  Ve as HoppGQLAuthInherit,
  ke as HoppGQLAuthNone,
  Bu as HoppGQLAuthOAuth2,
  Ms as HoppGQLRequest,
  Ar as HoppRESTAuth,
  Oe as HoppRESTAuthAPIKey,
  Je as HoppRESTAuthAWSSignature,
  Os as HoppRESTAuthAkamaiEdgeGrid,
  ye as HoppRESTAuthBasic,
  me as HoppRESTAuthBearer,
  Ot as HoppRESTAuthDigest,
  xs as HoppRESTAuthHAWK,
  ve as HoppRESTAuthInherit,
  Lu as HoppRESTAuthJWT,
  pe as HoppRESTAuthNone,
  Bu as HoppRESTAuthOAuth2,
  br as HoppRESTHeaders,
  Es as HoppRESTParams,
  Is as HoppRESTReqBody,
  Tr as HoppRESTRequest,
  Pp as HoppRESTRequestResponse,
  Gu as HoppRESTRequestResponses,
  Ts as HoppRESTRequestVariables,
  Rp as HoppRESTResponseOriginalRequest,
  Sp as ImplicitOauthFlowParams,
  Ie as OAuth2AdvancedParam,
  Ku as OAuth2AuthRequestParam,
  bp as PasswordGrantTypeParams,
  tl as RESTReqSchemaVersion,
  tg as ValidContentTypesList,
  mg as calculateAkamaiEdgeGridHeader,
  yg as calculateHawkHeader,
  vg as generateJWTToken,
  kt as generateUniqueRefId,
  gy as getDefaultGQLRequest,
  Xp as getDefaultRESTRequest,
  rg as isEqualHoppRESTRequest,
  sg as isHoppRESTRequest,
  zp as knownContentTypes,
  El as makeCollection,
  ig as makeGQLRequest,
  eg as makeHoppRESTResponseOriginalRequest,
  ag as makeRESTRequest,
  dg as parseBodyEnvVariables,
  ov as parseBodyEnvVariablesE,
  ug as parseRawKeyValueEntries,
  tv as parseRawKeyValueEntriesE,
  fg as parseTemplateString,
  cv as parseTemplateStringE,
  og as rawKeyValueEntriesToString,
  ng as safelyExtractRESTRequest,
  cg as strictParseRawKeyValueEntriesE,
  _y as translateToGQLRequest,
  hg as translateToNewEnvironment,
  uv as translateToNewEnvironmentVariables,
  Zy as translateToNewGQLCollection,
  Fy as translateToNewRESTCollection,
  ey as translateToNewRequest
};
